export const ServicesList = [
  {
    name: 'Business Development',
    slug: 'businessDevelopment',
    path: 'services/business-development',
    description: '',
    nestedSubMenu: {
      products: [
        {
          name: 'CRM by 360DevPro',
          slug: 'CRMby360DevPro',
          icon: 'crm-by-360devpro',
          path: 'business-development/CRMby360DevPro',
          shortDescription: 'Build strong customer relationships and win your customers’ loyalty with 360DevPro CRM Services ',
        },
        {
          name: 'Smart Setup by 360DevPro',
          slug: 'SmartSetup360DevPro',
          icon: 'smart-setup-360devpro',
          path: 'business-development/SmartSetup360DevPro',
          shortDescription: 'Our dedicated project managers will help you with setup processes in a most efficient way',
        },
        {
          name: 'SEO services by 360DevPro',
          slug: 'SEO360DevPro',
          icon: 'seo-services-360devpro',
          path: 'business-development/SEO360DevPro',
          shortDescription: 'Everything you need to boost your iGaming operation’s rankings on the Internet',
        },
        {
          name: 'User acquisition by Adera',
          slug: 'UserAdera',
          icon: 'user-acquisition',
          path: 'business-development/UserAdera',
          shortDescription: 'More customers - more income for your firm. Encourage customers to try your products and services!',
        },
        {
          name: 'Video and Creative production by Adera',
          slug: 'VideoCreativeAdera',
          icon: 'video-and-creative-production',
          path: 'business-development/VideoCreativeAdera',
          shortDescription: 'Grasp your user\'s attention with our video and creative production services!',
        },
        {
          name: 'Market research by 360DevPro',
          slug: 'Market360DevPro',
          icon: 'market-research',
          path: 'business-development/Market360DevPro',
          shortDescription: 'Identify growth opportunities and build competitive strategies with our market research services',
        },
        {
          name: 'One time setup by 360DevPro',
          slug: 'OneTime360DevPro',
          icon: 'one-time-setup-360devpro',
          path: 'business-development/OneTime360DevPro',
          shortDescription: 'Strategic setups for your gaming business with promotions, offers, banners, viral content and more ',
        },
        {
          name: 'Design Services by 360DevPro',
          slug: 'DesignServices360DevPro',
          icon: 'design-services-360devpro',
          path: 'business-development/DesignServices360DevPro',
          shortDescription: 'Get a custom design for your Website that will make it look unique and exclusive ',
        },
        {
          name: 'Digital Marketing Services by 360DevPro',
          slug: 'DigitalMarketingServices360DevPro',
          icon: 'digital-marketing-360devpro',
          path: 'business-development/DigitalMarketingServices360DevPro',
          shortDescription: 'From market research to strategy creation and campaign management - all aspects of digital marketing',
        },
        {
          name: 'Consulting by Adera',
          slug: 'ConsultingAdera',
          icon: 'consulting-by-adera',
          path: 'business-development/ConsultingAdera',
          shortDescription: 'Helping operators solve problems. Our product analytics team will detect & fix any issues.',
        },
        {
          name: 'Expert CRM',
          slug: 'ExpertCRM',
          icon: 'expert-crm',
          path: 'business-development/ExpertCRM',
          shortDescription: 'You visualize, we implement! Our team will handle everything related to CRM system management ensuring its effective usage. We will help you to save time, resources, additional hiring, and decrease the risks. ',
        },
        {
          name: 'Affiliate Program Management Service',
          slug: 'AffiliateProgramManagementService',
          icon: 'affiliate-program-management-service',
          path: 'business-development/AffiliateProgramManagementService',
          shortDescription: 'We provide a range of services to help businesses effectively manage and optimise your affiliate marketing programs. ',
        },
        {
          name: 'Brand awareness and media traffic by Adera',
          slug: 'BrandAdera',
          icon: 'brand-awareness-media-traffic',
          path: 'business-development/BrandAdera',
          shortDescription: 'If you\'re looking for marketing professionals to boost your company\'s performance, Adera is just what you need. ',
        },
        {
          name: 'Business Management by 360DevPro',
          slug: 'BusinessManagement360DevPro',
          icon: 'bussines-management-360devpro',
          path: 'business-development/BusinessManagement360DevPro',
          shortDescription: 'Everything your iGaming operation may ever need for website maintenance, management and improvement ',
        },
        {
          name: 'SMM Services by 360DevPro',
          slug: 'SMMServices360DevPro',
          icon: 'smm-360devpro',
          path: 'business-development/SMMServices360DevPro',
          shortDescription: 'From Social Media Market research to strategy creation and campaign management - all aspects of SMM',
        },
        {
          name: 'Animation Widget',
          slug: 'AnimationWidget',
          icon: 'animation-widget',
          path: 'business-development/AnimationWidget',
          shortDescription: 'We provide animations that cover events of the game in real-time, so users can engage more.',
        },
        {
          name: 'Swarm API',
          slug: 'SwarmAPI',
          icon: 'swarm-api',
          path: 'business-development/SwarmAPI',
          shortDescription: 'Welcome to the SWARM API, your gateway to seamless integration of diverse BetConstruct products, especially sportsbook feeds.',
        },
        {
          name: 'Poker Operations',
          slug: 'PokerOperations',
          icon: 'poker-operations',
          path: 'business-development/PokerOperations',
          shortDescription: 'Tournament and game management, promotions, consultancy, monitoring, risk management and data analysis - all come as part of the service pack from BetConstruct’s Poker Operations team.',
        },
        {
          name: 'Catalyst Law Services',
          slug: 'CatalystLawServices',
          icon: 'catalyst-law-services',
          path: 'business-development/CatalystLawServices',
          shortDescription: 'Thrive in the legal world with integrity, compliance, and success.',
        },
        {
          name: 'Bet Easy',
          slug: 'BetEasy',
          icon: 'bet-easy',
          path: 'business-development/BetEasy',
          shortDescription: 'Bet Easy - a cross-platform solution for seamless mobile app creation. With a unified UI/UX and streamlined integration options, partners can deliver enhanced user experiences on iOS and Android devices. Bet Easy include rapid development, gamification and personalisation features for users.',
        },
        {
          name: 'BBG Services',
          slug: 'BBGServices',
          icon: 'bbg',
          path: 'business-development/BBGServices',
          shortDescription: 'Have your solid and resolute position in the financial and legal sectors with BBG services.',
        },
        {
          name: 'Passionate',
          slug: 'Passionate',
          icon: 'passionate',
          path: 'business-development/Passionate',
          shortDescription: 'Stand out with thrilling colors and a distinctive brand!',
        },
        {
          name: 'Business Dashboard',
          slug: 'BusinessDashboard',
          icon: 'business-dashboard',
          path: 'business-development/BusinessDashboard',
          shortDescription: 'Improve professional efficiency and reveal current business indicators with Dashboard!',
        },
        {
          name: 'Business Lean-Agile Transformation',
          slug: 'BusinessLeanAgileTransformation',
          icon: 'business-lean-agile-transformation',
          path: 'business-development/BusinessLeanAgileTransformation',
          shortDescription: 'We offer to improve business performance, maximize survival, create value-added products or servicess',
        },
        {
          name: 'Digital Management Tools Integration',
          slug: 'DigitalManagementToolsIntegration',
          icon: 'digital-management-tools-integration',
          path: 'business-development/DigitalManagementToolsIntegration',
          shortDescription: 'We offer to optimize your flows, get digital solutions for standardization and decrease undue work',
        },
        {
          name: 'Lean-Agile Training & Consulting',
          slug: 'LeanAgileTrainingConsulting',
          icon: 'lean-agile-training-consulting',
          path: 'business-development/LeanAgileTrainingConsulting',
          shortDescription: 'This session will let you increase your practical and theoretical skills in Management and not only',
        },
      ]
    }
  },
  {
    name: 'Law',
    slug: 'law',
    path: 'services/law',
    description: '',
    nestedSubMenu: {
      products: [
        {
          name: 'Licensing Services',
          slug: 'licensingServices',
          icon: 'licensing',
          path: 'law/LicensingServices',
          shortDescription: `All about the licensing process via BetConstruct and the service fees for your iGaming operation`,
        },
        {
          name: 'Legal',
          slug: 'legal',
          icon: 'legal',
          path: 'law/Legal',
          shortDescription: `Company-Related Legal Documentation`,
        }
      ]
    }
  },
  {
    name: 'Sports And Gaming',
    slug: 'sportsAndGaming',
    path: 'services/sports-and-gaming',
    description: '',
    nestedSubMenu: {
      products: [
        {
          name: 'DTProService',
          slug: 'DTProService',
          icon: 'dtproservice',
          path: 'sports-and-gaming/DTProService',
          shortDescription: `Your business’s trading strategy creation and implementation.`,
        },
        {
          name: 'Exclusive Risk Management',
          slug: 'ExclusiveRiskManagement',
          icon: 'exclusive-risk',
          path: 'sports-and-gaming/ExclusiveRiskManagement',
          shortDescription: `Protect your iGaming business using the highly esteemed Exclusive Risk Management service, which offers unparalleled risk mitigation and safeguards to ensure the security of your business. `,
        },
        {
          name: 'Sport Fraud Fighter',
          slug: 'SportFraudFighter',
          icon: 'sport-fraud-fighter',
          path: 'sports-and-gaming/SportFraudFighter',
          shortDescription: `To protect our members, customers, and partners from fraud in sports and other events, we require a comprehensive strategy involving multiple sectors and nations.`,
        },
        {
          name: 'Branded live dealer tables by CreedRoomz',
          slug: 'BrandedDealerByCreedRoomz',
          icon: 'branded-live-dealer',
          path: 'sports-and-gaming/BrandedDealerByCreedRoomz', //TODO
          shortDescription: `CreedRoomz provides unique solutions for both dedicated tables and studios to make your brand distinctive.`,
        },
        {
          name: 'Wonder Wheel Promotional Tool',
          slug: 'WonderWheelPromotionalTool',
          icon: 'wonder-wheel',
          path: 'sports-and-gaming/WonderWheelPromotionalTool', //TODO
          shortDescription: `Wonder Wheel is a promotional tool that allows your players to spin the wheel for exciting prizes.`,
        },
        {
          name: 'iGaming Bot',
          slug: 'iGamingBot',
          icon: 'iGaming-bot',
          path: 'sports-and-gaming/iGamingBot',
          shortDescription: `in-Telegram application to play, chat and connect 1+ billion of people to your brand`,
        }
      ]
    }
  },
  {
    name: 'Other',
    slug: 'other',
    path: 'services/other',
    description: '',
    nestedSubMenu: {
      products: [
        {
          name: 'Customer Support',
          slug: 'CustomerSupport',
          icon: 'customer-support',
          path: 'other/CustomerSupport',
          shortDescription: `Experienced Live Customer Support in over 16 languages, 24/7`,
        },
        {
          name: 'Data replication Services',
          slug: 'DataReplicationServices',
          icon: 'data-replication-services',
          path: 'other/DataReplicationServices',
          shortDescription: `Deliver real-time data to derive better insights.`,
        },
        {
          name: 'Enigma',
          slug: 'Enigma',
          icon: 'enigma',
          path: 'other/Enigma',
          shortDescription: `Improve your data quality and use our insights to better target your customers.`,
        },
        {
          name: 'Event Management and Logistics Services',
          slug: 'EventManagementLogisticsServices',
          icon: 'event-management-logistics-services',
          path: 'other/EventManagementLogisticsServices',
          shortDescription: `Wide range of services starting from ad placement advisory to stand design and construction.`,
        },
      ]
    }
  },
]

export const ServicesMenu = [
  //-------------------------------------------------------> Business Development
  {
    name: 'CRM by 360DevPro',
    slug: 'CRMby360DevPro',
    icon: 'crm-by-360devpro',
    path: 'business-development/CRMby360DevPro',
    shortDescription: 'Build strong customer relationships and win your customers’ loyalty with 360DevPro CRM Services ',
    description: `
<div><img src=${require('../assets/imgs/services/CRMServices360DevPro.png').default} width="689" alt=""></div>
</br>
<p>360DevPro CRM Service will provide the best experience to your customers driving long-lasting relationships.</p>
</br>
<p>You can improve your iGaming business relationships, nurture your leads, convert them into customers and boost your productivity with our robust CRM. Use the service to manage and analyse customer interactions and data throughout the entire customer lifecycle.  </p>
</br>
<p>We offer an individual approach to all our partners. That helps them boost their business performance and sales.</p>
</br>
<p>Our CRM Solution will assist you with growing your target audience and help you save hours in your daily operations through automated one-to-one multi-channel communication: emails, internal messages, phone SMS texts, and more.</p>
</br>
<p>360DevPro CRM automates routine processes and provides tools to track and measure the productivity and effectiveness of running campaigns, promos, and customer journeys. </p>
</br>
<p>There are different packages of CRM Services available. </p>
<ul>
<li>CRM Activity that includes creation of Custom Campaigns, Customer Journeys, Bonuses and Promotions, etc.</li>
<li>CRM Support that includes creation of Standard Campaigns, Customer Journeys, Reports, Support and Monitoring.</li>
</ul>`,
    pricing:`
<div>
<div>
<table><colgroup><col width="500"><col width="100"></colgroup>
<tbody>
<tr>
<td><strong>CRM Activity</strong></td>
<td><strong>€7,000</strong></td>
</tr>
<tr>
<td><span>Creation of Campaigns</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Creation of Customer Journeys</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Creation of Segments</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Creation of Bonuses</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Creation of Promotions</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Creation of content and design of the templates</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Creation of terms and conditions of bonuses</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Testing all the created bonuses, campaigns, templates and customer journeys</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Monitoring ongoing promotions</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Analysing the promos and providing analytical reports</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Testing all the created bonuses, campaigns, templates, and customer journeys</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Monitoring ongoing promotions&nbsp;</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Analysing the promos and providing analytical reports</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Setup of Bonuses and Promos</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Design of the appropriate Elements</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Distinctive approach to valuable players</span></td>
<td>&nbsp;</td>
</tr>
</tbody>
</table>
</div>
</div>
`
  },
  {
    name: 'Smart Setup by 360DevPro',
    slug: 'SmartSetup360DevPro',
    icon: 'smart-setup-360devpro',
    path: 'business-development/SmartSetup360DevPro',
    shortDescription: 'Our dedicated project managers will help you with setup processes in a most efficient way',
    description: `<div><img src=${require('../assets/imgs/services/SmartSetup360DevPro.png').default} width="689" alt=""></div>
</br>
<p>Known as Smart Setup, our service offers numerous features to our operators who in their turn are required to carry out some technical work on their end. However, it’s not always that operators can find time and resources or acquire the necessary knowledge to perform tasks successfully.</p>
</br>
<p>We, therefore, suggest assigning dedicated project managers to the operators who use our operational services, specifically those that require one-time setup. With strong knowledge and experience related to website configurations, product management, content and all the relevant tools, the project manager’s contribution can be essential.</p>
</br>
<p>PMs will be assigned to help both existing and potential operators. Interactive group chats may be used as a form of communication. Reports and updates will be sent to the operators on a daily basis throughout and after the setup. Post-launch support will be provided by the PM to ensure a smooth operation flow.</p>
</br>
<p><strong>WORK SCOPE</strong></p>
</br>
<p><strong>Market research and competitors analysis</strong></p>
<ul>
<li>Popular websites in the market</li>
<li>Popular games in the market</li>
<li>Popular game providers</li>
<li>Popular communication channels with customers (SMS, Email, etc)</li>
<li>Popular payment methods in the market</li>
<li>UI/UX of competitors' websites</li>
<li>The product offering of competitors</li>
<li>Sports offering of competitors</li>
<li>Welcome and other offers</li>
</ul>
</br>
<p><strong>Advisory on website solution</strong></p>
<ul>
<li>Website structure</li>
<li>Pages layout</li>
<li>Fast registration</li>
<li>Profile verification</li>
<li>Footer</li>
</ul>
</br>
<p><strong>Custom CSS coding</strong></p>
</br>
<p><strong>Design with SpringBuilder</strong></p>
</br>
<p><strong>Games Management</strong></p>
<ul>
<li>Casino games categorisation</li>
<li>Casino games ordering</li>
<li>Sports ordering down to the market level</li>
<li>Competitive odds setup</li>
<li>Competitive sports limits</li>
</ul>
</br>
<p><strong>Content Management</strong></p>
<ul>
<li>Uploading banners</li>
<li>Uploading text content</li>
<li>Adding missing translations (within supported languages, SB)</li>
</ul>
</br>
<p><strong>Enable "nice-to-have" features</strong></p>
<ul>
<li>Sports leagues highlights</li>
<li>Sports matches highlights</li>
<li>Advanced animations (for some trial period)</li>
<li>Sports stats for some trial period</li>
<li>Live sports video streaming for a certain trial period</li>
<li>Casino network tournaments</li>
<li>Latest improved functionality</li>
<li>Fast withdrawals configuration</li>
</ul>
</br>
<p><strong>Advisory on account verification and KYC</strong></p>
<ul>
<li>Email, Phone and other verifications to ensure valid communication channels</li>
<li>KYC steps setup with related restrictions and order</li>
</ul>
</br>
<p><strong>Player communications</strong></p>
<ul>
<li>Email templates creation and setup (system email messages: welcome, reset password etc.)</li>
<li>Email provider setup for system messages</li>
<li>Email provider setup for CRM promotional messages</li>
<li>SMS provider setup for automated messages (if applicable)</li>
<li>SMS provider setup for CRM promotional messages (if applicable)</li>
</ul>
</br>
<p><strong>Assistance, including post-launch</strong></p>
<ul>
<li>Working with back office</li>
<li>Working with bonus engine</li>
<li>Working with Affiliates/agents system</li>
<li>Working with CRM</li>
<li>Working with website CMS</li>
<li>Working with payment providers</li>
<li>Configuring payment merchant accounts</li>
<li>Domain management</li>
</ul>
</br>
<p><strong>Reporting on a daily basis</strong></p>
`,
    pricing: `
<div>
<div>
<table><colgroup><col width="439"><col width="161"></colgroup>
<tbody>
<tr>
<td><strong>Smart Setup</strong></td>
<td><strong>€3,000</strong></td>
</tr>
<tr>
<td><span>Market research and competitors analysis</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Advisory on website solution</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Custom CSS coding</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Games Management</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Content Management</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Enable "nice-to-have" features</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Advisory on account verification and KYC</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Player communications</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Assistance, including post-launch</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Reporting on a daily basis</span></td>
<td>&nbsp;</td>
</tr>
</tbody>
</table>
</div>
</div>`
  },
  {
    name: 'SEO services by 360DevPro',
    slug: 'SEO360DevPro',
    icon: 'seo-services-360devpro',
    path: 'business-development/SEO360DevPro',
    shortDescription: 'Everything you need to boost your iGaming operation’s rankings on the Internet',
    description: `<div><img src=${require('../assets/imgs/services/SEO360DevPro.png').default} width="689" alt=""></div>
</br>
<p>Search engines are considered to be the main source of website traffic. If you want your website to be found, your website needs to be indexed on major search engines and ranked highly.</p>
</br>
<p>SEO will help you build strong relationships with your audience, improve user experience, increase your domain authority, drive more people to your site, give you an edge over the competition and increase conversions, which means more sales, more loyal customers, and more growth for your business.</p>
</br>
<p>Properly implemented SEO will gain you popularity in the gaming/betting world.</p>
</br>
<p>If you want your website to be successful, you need to make sure that it is SEO-friendly and optimised for the gaming community.</p>
</br>
<p>SEO Services focus on 3 main components:</p>
<ul>
<li>On-Page SEO - which focuses on the optimisations related to your website, like your meta tags, content, URL structure;</li>
<li>Off-Page SEO - which focuses on the optimisations related to your online existence, like your website’s backlinks;</li>
<li>Technical SEO - covers all of the technical aspects of the website that affect SEO, from hosting and site speed to XML sitemaps and robots.txt files.</li>
</ul>
<p>Getting your business to rise from being an unknown online betting website to ranking on the first pages of Google, Yandex, or Yahoo for high-difficulty keywords will take time and patience. However, our specialists are here to help you gain more organic traffic to your website through numerous well-practiced SEO techniques.</p>`,
    pricing: `
<div>
<div>
<table><colgroup><col width="460"><col width="140"></colgroup>
<tbody>
<tr>
<td>Search Engine Optimisation Full Package (SEO)</td>
<td>€3,500 - €6,000</td>
</tr>
<tr>
<td>Additional language</td>
<td>€500 Each</td>
</tr>
<tr>
<td>On-site SEO</td>
<td>€2,600-€4,300</td>
</tr>
<tr>
<td>Off-site SEO</td>
<td>€1,700-€2,600</td>
</tr>
</tbody>
</table>
</div>
</br>
<p>Please request a quote for details about each package.</p>
</div>
`
  },
  {
    name: 'User acquisition by Adera',
    slug: 'UserAdera',
    icon: 'user-acquisition',
    path: 'business-development/UserAdera',
    shortDescription: 'More customers - more income for your firm. Encourage customers to try your products and services!',
    description: `
<div><img src=${require('../assets/imgs/services/UserAcquisitionAdera.png').default} width="689" alt=""></div> 
</br>
<p><b>Regardless of whether the product is a casino or a betting site, brand recognition and user acquisition are two crucial strategies for driving traffic to the product. Being among the major media traffic holders in the CIS, Asia, Latham, and Europe, Adera is sure that building brand awareness is primarily concerned with garnering audience attention and expanding brand familiarity. Daily, we provide our partners with countless millions of efficient advertising impressions. Each week, we will provide you with a comprehensive report presentation with a summary of the campaign's performance and all outcome variables. All reports are customised depending on your parameters and preferences. Our team of genuine experts will assist you in attaining a significant position in the market.</b></p>
</br>
<p>The main aspect of user acquisition is just the opposite of media advertising. The main goal here is to attract the user to the website as cheaply and quickly as possible to perform the targeted action (registration, FTD, STD, etc.) The main channels for this type of traffic are Google (Adwords, UAC, Display Network), Facebook and other social networks and instant messengers. We use ultra-precise targeting tools for the abovementioned traffic sources to attract the target player as quickly and efficiently as possible. Attracting an audience by this method is almost always cheaper than by media advertising, thus it does not affect brand awareness in any way, since interaction with the user is generally personalized. The main model for purchasing such traffic is CPA (Pay per player) Without constant work with media advertising and brand awareness support, work with CPA or later hit the ceiling. We launch advertising campaigns both for a fixed CPA and an open commission from the campaign budget. </p>
`,
    pricing: `
<div>
<div>
<div>
<div>
<div>
<p>A fixed price will be agreed upon between the parties for a single project.</p>
</br>
<p>Pricing list</p>
</br>
</div>
</div>
<table cellpadding="3">
<tbody>
<tr>
<td>
<div>
<div>
<p>Service</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>Cost</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Budget strategy &amp; planning</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>1000$</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Marketing &amp; product audition</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>3000$</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Analytics audition &amp; set up</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>2000$</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Retention set up</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>3000$</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>After set up marketing and technical support/control</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>1000$ per month</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Campaign creation</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>4000$</p>
</div>
</div>
</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>`
  },
  {
    name: 'Video and Creative production by Adera',
    slug: 'VideoCreativeAdera',
    icon: 'video-and-creative-production',
    path: 'business-development/VideoCreativeAdera',
    shortDescription: 'Grasp your user\'s attention with our video and creative production services!',
    description: `
<div><img src=${require('../assets/imgs/services/VideoCreativeProductionAdera.png').default} width="689" alt=""></div>
</br>
<p>Regardless of whether the product is a casino or a betting site, brand recognition and user acquisition are two crucial strategies for driving traffic to the product. Being among the major media traffic holders in the CIS, Asia, Latham, and Europe, Adera is sure that building brand awareness is primarily concerned with garnering audience attention and expanding brand familiarity. Daily, we provide our partners with countless millions of efficient advertising impressions. Each week, we will provide you with a comprehensive report presentation with a summary of the campaign's performance and all outcome variables. All reports are customised depending on your parameters and preferences. Our team of genuine experts will assist you in attaining a significant position in the market.</p>
</br>
<p>Having delivery integrity in mind we are not limiting ourselves with working with traffic or product development and analytics, we are creating a full-fledged funnel for users, which always starts with creatives, whose main task is to maximize the user's attention.</p>
<p>Our field of expertise includes:</p>
</br>
<p>- Development of creative strategies</p>
</br>
<p>- Creation of creative concepts</p>
</br>
<p>- Creation of static and interactive html5 creatives (banners, stickers, branding in . formats) </p>
</br>
<p>- Creation of landing pages (from design to layout)</p>
</br>
<p>- Creation of video clips of any complexity</p>
`,
    pricing: `
<p>A fixed price will be agreed between the parties for a single project.</p>`
  },
  {
    name: 'Market research by 360DevPro',
    slug: 'Market360DevPro',
    icon: 'market-research',
    path: 'business-development/Market360DevPro',
    shortDescription: 'Identify growth opportunities and build competitive strategies with our market research services',
    description: `
<div><img src=${require('../assets/imgs/services/MarketResearch360DevPro.png').default} width="689" alt=""></div>
</br>
<p>Each successful business must rely on a robust and comprehensive market research strategy while employing large-scale business processes. Properly generated market research data and actionable insights give you an accurate idea of where you stand in the market and how far you can go.</p>
</br>
<p>An extensive Competitor Analysis will help you measure yourself against your competitors and highlight the industry gaps. Understanding what your competitors do, and what their customers' biggest pain points are, will give you valuable input for your upcoming business strategies. </p>
</br>
<p>With a professionally handled data-driven approach, you can make sure that your website content and design match the market trends and meet your user’s interests. Keeping in mind that offered promotions and bonuses are super-crucial for gaming platforms, we will conduct a preliminary analysis to offer the users promotions that will score maximum effectiveness and conversions.</p>
</br>
<p>Trust us now, thank yourself later.</p>
`,
    pricing: `
<div>
<div>
<table><colgroup><col width="439"><col width="161"></colgroup>
<tbody>
<tr>
<td><strong>Market Research</strong></td>
<td><strong>€1,000</strong></td>
</tr>
<tr>
<td><span>Competitors’ research</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Analysis of Content and UI</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Analysis of offered Bonuses and Promos</span></td>
<td>&nbsp;</td>
</tr>
</tbody>
</table>
</div>
</div>`
  },
  {
    name: 'One time setup by 360DevPro',
    slug: 'OneTime360DevPro',
    icon: 'one-time-setup-360devpro',
    path: 'business-development/OneTime360DevPro',
    shortDescription: 'Strategic setups for your gaming business with promotions, offers, banners, viral content and more ',
    description: `
<div><img src=${require('../assets/imgs/services/OneTimeSetup360DevPro.png').default} width="689" alt=""></div>
</br>
<p>To start large-scale business processes, you need to have firm and profound roots in the form of a correctly organised and structured setup. It is beyond essential how your product looks before the big launch, as the first impression never gets forgotten. Your promotions and offers, banners, content and configurable functionalities require particular attention and need to be treated with the highest responsibility and professionalism. And here it’s our turn to come on the board. </p>
</br>
<p>The 360DevPro skilled team ensures smooth and well-ordered implementation of a one-time setup of your gaming business by executing the most successful practices in the market. Appealing promotions and banners, alongside accurately inserted winsome content and core functionalities will result in a killer website. </p>
</br>
<p>By trusting us with the setup of your website, you can confidently go in for your customers.</p>
`,
    pricing: `
<div>
<div>
<table><colgroup><col width="429"><col width="171"></colgroup>
<tbody>
<tr>
<td><strong><span>One Time Setup</span></strong></td>
<td><strong><span>Starting from €10,000</span></strong></td>
</tr>
<tr>
<td><span>Competitors’ research</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Analysis of Bonuses and Promos</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Creation and Set-up of Bonuses and Promos</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Banner Creation</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Content Creation</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Set-up of required Functionalities</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Creation of HTML email templates for CRM</span></td>
<td>&nbsp;</td>
</tr>
</tbody>
</table>
</div>
</div>`
  },
  {
    name: 'Design Services by 360DevPro',
    slug: 'DesignServices360DevPro',
    icon: 'design-services-360devpro',
    path: 'business-development/DesignServices360DevPro',
    shortDescription: 'Get a custom design for your Website that will make it look unique and exclusive ',
    description: `
<div><img src=${require('../assets/imgs/services/DesignService360DevPro.png').default} width="689" alt=""></div>
</br>
<p>Every business needs to be unique. Stand out from your competitors with a thought-out, effective and original webpage design that closely meets the vision of your business. Our web design services utilise intelligent design strategies to create a remarkable website that is easy to navigate, user-friendly and mobile-responsive. Depending on the platform you’ve chosen, you’ll get the most effective bespoke website design that sets you apart from others. </p>
</br>
<p>With an accurate design, clever messaging and compelling banner visuals we will make your website easy to recognise and hard to forget. It’s not enough to just rely on exceptional content. You make your marketing efforts more impactful by pairing valuable content with a visually appealing design.</p>
</br>
<p>With 360DevPro, you will bring your visions to life, shine out and leave a lasting impression</p>
</br>
<p><strong>Branding</strong></p>
</br>
<p>We take care of your branding while you focus on your business. Let our professionals take care of your brand identity and create a unique, personalised and memorable logo and logo book (brand book) for you. </p>
</br>
<p>Your brand identity cultivates the tone of voice, personality and the values of your company. Our team of professionals will create a tailored style guide to advise you on the best practices of logo usage, colours and messaging to suit the vision and insight of your unique brand. </p>
</br>
<p>Key Features:</p>
<ul>
<li>Logo and Favicon creation</li>
<li>Colors</li>
<li>Fonts</li>
<li>Design of different elements</li>
<li>Brand strategy</li>
<li>Design of the homepage based on the existing templates</li>
</ul>
</br>
<p>What matters most in creating a brand differentiator is knowing and understanding your target audience, their preferences and their personae. Leverage our talented team of designers to create your brand identity that will leave a lasting impact in the market and become the users’ favourite one. </p>
`,
    pricing: `
<div>
<div>
<table><colgroup><col width="422"><col width="178"></colgroup>
<tbody>
<tr>
<td><strong>UI/UX &amp; Graphic Design</strong></td>
<td><strong>€Starting From 4,000</strong></td>
</tr>
<tr>
<td><strong>Logo &amp; Brandbook</strong></td>
<td><strong>€4,000&nbsp;( One time fee )</strong></td>
</tr>
<tr>
<td><span>Logo creation</span></td>
<td><span>Once</span></td>
</tr>
<tr>
<td><span>Colors</span></td>
<td><span>Once</span></td>
</tr>
<tr>
<td><span>Fonts</span></td>
<td><span>Once</span></td>
</tr>
<tr>
<td><span>Elements</span></td>
<td><span>Once</span></td>
</tr>
<tr>
<td><span>Brand identity package</span></td>
<td><span>Once</span></td>
</tr>
<tr>
<td><strong>Promotional Materials</strong></td>
<td><strong>€1,500</strong></td>
</tr>
<tr>
<td><span>Sliders</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Thumbnails</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Email templates&nbsp;</span></td>
<td>&nbsp;</td>
</tr>
</tbody>
</table>
</div>
</div>
`
  },
  {
    name: 'Digital Marketing Services by 360DevPro',
    slug: 'DigitalMarketingServices360DevPro',
    icon: 'digital-marketing-360devpro',
    path: 'business-development/DigitalMarketingServices360DevPro',
    shortDescription: 'From market research to strategy creation and campaign management - all aspects of digital marketing',
    description: `
<div><img src=${require('../assets/imgs/services/DigitalMarketingServices360DevPro.png').default} width="689" alt=""></div>
</br>
<p>We are here to help you define a strong brand communication strategy in this digital age. Our professional team of marketing experts, data analysts and campaign strategists will handle your gaming business’ digital marketing from A to Z. Here’s how we do it. </p>
</br>
<ul>
<li>We start by doing research on your business, target market, audience, competitors, industry benchmarks in your target region and the main channels used for advertising.  </li>
<li>Then we proceed to auditing your performance, past actions and results. </li>
<li>When all the data is collected, we start creating your strategy. Powerful marketing strategy is the key to business success. Drive sales with the help of innovative marketing activities implemented by industry experts. The strategy includes your entire business identity, messaging, vision, main used channels, advertising messages, promotional materials and market penetration steps. </li>
<li>Our entire work is measured by KPIs that we set together. We make sure you are aware of what we’re doing, and that you know what results to expect.</li>
</ul>
</br>
<p>We try to focus mainly on non-standard placements with high user involvement, ultra-innovative ad formats and counting mechanisms. Heavily influenced by media placements and digital ads, we try to optimise users’ interactions with the ads. We offer banner and video placements as part of our media-buying service and media-planning service, both being the most effective placement types in the modern digital world.</p>
<ul>
<li><strong>Market research and strategy. </strong><span>Know your strength, find your audience and target it.</span></li>
<li><strong>Email Marketing.</strong><span> Turn email marketing into a lead- and revenue-generating resource. Solution that includes developing, implementing, and managing your email strategy, as well as measuring its impact on lead generation, sales, and revenue.</span><span><br></span></li>
<li><strong>PPC Campaigns (if local license exists).</strong><span> Let us drive your PPC campaigns towards your goals. From Google Ads to Facebook ads, we help you reach your buyers on the paid platforms that are most effective.</span><span><br></span></li>
<li><strong>Influencer Marketing.</strong><span> Identifying, researching, engaging and supporting the people who create high-impact conversations with customers about your brand.</span><span><br></span></li>
<li><strong>Tracking and Analytics.</strong><span> We provide digital marketing analytics services and actionable recommendations to measurably improve ad performance.</span></li>
<li><strong>Media Buying.</strong><span> Increase your visibility in the preferred regions and websites.</span></li>
</ul>
</br>
<p><span>With 360DevPro, you will gain a full spectrum of digital marketing services that will make your brand steal the show in the competition and win more and more loyal customers.</span></p>
`,
    pricing: `
<div>
<div>
<table><colgroup><col width="430"><col width="170"></colgroup>
<tbody>
<tr>
<td><strong>Digital Marketing</strong></td>
<td><strong>Starting from €5,000</strong></td>
</tr>
<tr>
<td><span>Competitors’ research</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Strategy Development</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Email Marketing</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>PPC Campaigns</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Influencer Marketing</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Tracking and Analytics</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Media Buying</span></td>
<td>&nbsp;</td>
</tr>
</tbody>
</table>
</div>
</div>
`
  },
  {
    name: 'Consulting by Adera',
    slug: 'ConsultingAdera',
    icon: 'consulting-by-adera',
    path: 'business-development/ConsultingAdera',
    shortDescription: 'Helping operators solve problems. Our product analytics team will detect & fix any issues.',
    description: `
<div><img src=${require('../assets/imgs/services/ConsultingAdera.png').default} width="689" alt=""></div>
</br>
<p>Regardless of whether the product is a casino or a betting site, brand recognition and user acquisition are two crucial strategies for driving traffic to the product. Being among the major media traffic holders in the CIS, Asia, Latham, and Europe, Adera is sure that building brand awareness is primarily concerned with garnering audience attention and expanding brand familiarity. Daily, we provide our partners with countless millions of efficient advertising impressions. Each week, we will provide you with a comprehensive report presentation with a summary of the campaign's performance and all outcome variables. All reports are customised depending on your parameters and preferences. Our team of genuine experts will assist you in attaining a significant position in the market.</p>
</br>
<p>Very often operators complain about lack of “conversion” on a product, or low Reg2Dep conversion stats, or players churn after the first deposit. To help operators to solve those issues we are running a product analytics unit, which helps to find and tackle the following issues in the following fields:</p>
<ul>
<li>
<p>Marketing & product audit and analysis</p>
</li>
<li>
<p>Analytics audit & set up</p>
</li>
<li>
<p>Review of existing retention or set up it from scratch</p>
</li>
<li>
<p>Budget planning and strategy</p>
</li>
<li>
<p>After set up marketing and technical support/control</p>
</li>
</ul>
`,
    pricing: `
<p>A fixed price will be agreed between the parties for a single project.</p>
`
  },
  {
    name: 'Expert CRM',
    slug: 'ExpertCRM',
    icon: 'expert-crm',
    path: 'business-development/ExpertCRM',
    shortDescription: 'You visualize, we implement! Our team will handle everything related to CRM system management ensuring its effective usage. We will help you to save time, resources, additional hiring, and decrease the risks. ',
    description: `
<div><img src=${require('../assets/imgs/services/ExpertCRM.png').default} width="689" alt=""></div>
</br>
<div><p>We offer our partners the following service packages:</p>
<p><strong> Full Service</strong></p>
<ul>
<li><strong>Segment creation</strong>: Targeting specific groups of customers for personalized campaigns.</li>
<li><strong>Campaign creation</strong>: Automation of Marketing Campaigns for customers' acquisition, conversion, retention, reactivation, and other purposes.</li>
<li><strong>Customer Journey creation</strong>: Building real-time Customer Journeys for new leads’ onboarding, and improvement of customer engagement guiding them through different flows based on their preferences and behavior.</li>
<li><strong>Report creation</strong>: generation of reports for analytics, legal reporting, managerial reviews, and more.</li>
<li><strong>Bonus creation</strong>: all types of bonuses setup, including Cashbacks, to award customers through CRM to retain and engage them.</li>
<li><strong>Monitoring ongoing promotions</strong> to track their effectiveness or prevent any risks.</li>
<li>Dedicated support in <strong>English, Russian, Turkish</strong> and <strong>Arabic</strong> languages.</li>
<li><strong>Direct communication</strong> with the CRM Service team for quick and effective cooperation.</li>
</ul>
<p><strong> Partial Service</strong></p>
<ul>
<li><strong>User Training</strong>: training sessions to educate our partner’s staff on how to effectively and accurately use the CRM tool.</li>
<li><strong>Direct communication</strong> with the CRM Service Team for quick and effective interactions.</li>
<li><strong>Technical Review</strong> of Segments, Campaigns, CJs, Reports created by partner staff.</li>
<li>Dedicated support in <strong>English, Russian, Turkish</strong> and <strong>Arabic</strong> languages.</li>
</ul></div>
`,
    pricing: `
<div>
<p>Full Service – €2000 Monthly</p>
</br>
<p>Partial service - €1000 Monthly</p>
</div>
`
  },
  {
    name: 'Affiliate Program Management Service',
    slug: 'AffiliateProgramManagementService',
    icon: 'affiliate-program-management-service',
    path: 'business-development/AffiliateProgramManagementService',
    shortDescription: 'We provide a range of services to help businesses effectively manage and optimise your affiliate marketing programs. ',
    description: `
<div><img src=${require('../assets/imgs/services/AffiliateProgramManagement.png').default} width="689" alt=""></div>
</br>
<div>
<p>Start enhancing your affiliate marketing plan by utilizing our all-inclusive Affiliate Management service. Our team provides an array of specialized services that are tailored to help you amplify your ROI and boost conversions.
</br>Training and Consulting: We will provide comprehensive training sessions to your staff members to ensure they can utilise the system effectively. This can include live webinars, pre-recorded videos, step-by-step guides, and FAQs.
</br>Landing page visual and content customization: We offer customization services to help your landing pages stand out and effectively convey your brand message. 
</br>Global configuration setups: We can help you configure the system to your unique needs, including regional and language-specific settings.
</br>Commission plan setup based on market: We will work with you to develop commission plans that align with market trends and incentivize affiliates to drive more conversions.
</br>Contribution cost setup: We can assist you in setting up contribution costs to manage your budget and ensure maximum ROI.
</br>Direct support channels (Skype, Telegram, WhatsApp, etc.): We offer multiple support channels to cater to your preferences and ensure prompt responses to queries and issues.
</br>Link and media creation support: We can help you create effective affiliate links and media assets, such as banners and ads, to drive traffic and boost conversions.
</br>Postback setup: We can set up postbacks to track conversions and provide you with real-time data on your campaign performance.
</p>
</br>
<p>Stop getting weighed down by managing your affiliate program on your own. Allow us to take charge with our exceptional coaching and consultation, customized landing pages, worldwide settings configuration, and other valuable services. Our team is committed to supporting you with direct communication channels, assistance with creating links and media, and postback setup for instantaneous data. Get in touch with us today to discover how we can simplify your affiliate program and help you accomplish your marketing objectives.</p></div>
`,
    pricing: `
<div>
<table>
<tbody>
<tr>
<td>Training and Consulting</td>
<td>500 Euro monthly</td>
</tr>
<tr>
<td>Landing page visual and content customization</td>
</tr>
<tr>
<td>Global configuration setups</td>
</tr>
<tr>
<td>Commission plan setup based on market</td>
</tr>
<tr>
<td>Contribution cost setup</td>
</tr>
<tr>
<td>Direct support channels</td>
</tr>
<tr>
<td>Link and media creation support</td>
</tr>
<tr>
<td>Poshback setup</td>
</tr>
</tbody>
</table>
</div>
`
  },
  {
    name: 'Brand awareness and media traffic by Adera',
    slug: 'BrandAdera',
    icon: 'brand-awareness-media-traffic',
    path: 'business-development/BrandAdera',
    shortDescription: 'If you\'re looking for marketing professionals to boost your company\'s performance, Adera is just what you need. ',
    description: `
<div><img src=${require('../assets/imgs/services/BrandAwarenessMediaTrafficAdera.png').default} width="689" alt=""></div>
</br>
<p><strong>Regardless of whether the product is a casino or a betting site, brand recognition and user acquisition are two crucial strategies for driving traffic to the product. Being among the major media traffic holders in the CIS, Asia, Latham, and Europe, Adera is sure that building brand awareness is primarily concerned with garnering audience attention and expanding brand familiarity. Daily, we provide our partners with countless millions of efficient advertising impressions. Each week, we will provide you with a comprehensive report presentation with a summary of the campaign's performance and all outcome variables. All reports are customised depending on your parameters and preferences. Our team of genuine experts will assist you in attaining a significant position in the market.</strong></p>
</br>
<p>Two major models to drive traffic to products are brand awareness and user acquisition regardless of whether it's being casino or betting. The main objective of building brand awareness lies in gaining the audience’s attention and increasing brand recognition. In this model respectively the user does not always immediately go to the website after а creative display has been displayed.</p>
</br>
<p>Frequently after multiple interactions with media advertising, the user becomes interested in the advertised product, searches for it and finds it via search engines or traffic sources i.e. social networks, messengers and affiliates.</p>
</br>
<p>The basis of brand awareness is media advertising. As a rule, it includes video ads, banners, stickers and other attention-grabbing formats on various entertainment resources, news and sports resources, online cinemas and other websites. The main model for purchasing the mentioned type of traffic is CPM (cost per 1000 ad impressions)</p>
</br>
<p>Media advertising simultaneously solves the following tasks:</p>
</br>
<p>Introduces the audience to the product and its distinctive characteristics. In other words, it increases the brand awareness rate.</p>
</br>
<p>Increases confidence in the product. According to many sociological and marketing studies, the more often a user (a potential consumer of a service) communicates/interacts with an advertisement of a product, the more likely he will use the advertised service as the product already seems familiar, perceivable and credible for the user. After all, not every customer is ready to entrust their money and time to an operator with no or little experience.</p>
</br>
<p>Attracts a new audience. One way or another, many users are drawn into the funnel at first sight by immediately clicking on the creative, following the link and performing targeted actions (registration, FTD, etc.)</p>
<ul>
<li>
<p>Maintains constant contact with an already active audience. Over time, even the most active players may lose their interest in the product. However, thanks to media advertising and brand awareness, the operator maintains contact with its entire audience, keeping it updated with new promotions, events, and special offers for specific segments of players. This makes media advertising and brand awareness one of the most important Retention tools.</p>
</li>
<li>
<p>Supports CPA buying. The more people know about your product, the easier and most importantly - cheaper to attract new players through other traffic sources. As a rule, media campaigns significantly reduce the cost of CPA for purchasing operators, since affiliates take significantly less time and resources to attract the attention of the player, engage him and bring him to the product.</p>
</li>
</ul>
<p>In this way, media advertising solves the most important tasks of the product by raising its brand awareness. There is not a single major operator who would not buy media advertising not investing in brand awareness.</p>
</br>
<p>Adera is one of the largest holders of media traffic in the CIS, Asia, Latham and Europe. Every day we send hundreds of millions of effective advertising impressions to our partners. We work with all types of media traffic, including the largest online cinemas, sports sites, news resources, video hosting, torrents, adult resources and many other entertainment resources. There are no intermediaries between us and webmasters, which guarantees the best purchase rates for our partners.</p>
`,
    pricing: `
<p>Based on the objective and location, we build a specific media strategy with required traffic sources and viable solutions to complex situations. We purchase traffic, manage analytics and quality, and measure performance using KPIs. In our Adserver's personal account, real-time statistics and indicators are accessible. We provide you with a weekly report presentation with a campaign overview and interim outcomes. All reports are customised to your needs. Personal account manager and analyst complement each campaign. Campaign monitoring is carried out 24/7.</p>
`
  },
  {
    name: 'Business Management by 360DevPro',
    slug: 'BusinessManagement360DevPro',
    icon: 'bussines-management-360devpro',
    path: 'business-development/BusinessManagement360DevPro',
    shortDescription: 'Everything your iGaming operation may ever need for website maintenance, management and improvement ',
    description: `
<div><img src=${require('../assets/imgs/services/BusinessManagement360DevPro.png').default} width="689" alt=""></div>
</br>
<p><span>Every now and then, your gaming and betting website may call for optimisation and performance improvement. Yet, i</span><span>t takes more than just having a website to run an iGaming business. Most importantly, you need to look after it and enhance it.</span></p>
</br>
<p><span>This is where our comprehensive business management services come in handy.</span></p>
<ul>
<li><span>We build industry-standard strategies and develop plans to attain the defined objectives in addition to displaying relevant content.</span></li>
<li><span>We conduct research to better understand markets and customer needs, alongside providing the most up-to-date real-time information on new promotions, bonuses, tournaments, games, matches, and offers.</span></li>
<li><span>We periodically refresh the website design, texts, banners, and products.</span></li>
<li><span>We oversee operations and assist your company in achieving maximum efficiency and top revenue levels.</span></li>
<li><span>We professionally handle new players and growth in revenue.</span></li>
<li><span>We manage additional challenges such as increased pressure on operational workloads.</span></li>
<li><span>We help you understand who your players are, where the money is coming from and how to sustainably retain new players.</span></li>
<li><span>We mitigate all possible risks.</span></li>
</ul>
<p><span>Tailored to companies’ specific requirements and goals, our b</span><span>usiness management services are aimed at </span><span>iGaming operators, land-based operators, regulators, startups, gaming managers, general managers, finance managers, marketing managers, customer experience managers, CEO, CFO, CMO, customer acquisition and retention specialists.&nbsp;</span></p>
</br>
<p><span>Our experts are available 24 hours a day, 7 days a week, to keep your website up and running. Please do not hesitate to contact us.</span></p>
`,
    pricing: `
<div>
<div>
<table><colgroup><col width="422"><col width="178"></colgroup>
<tbody>
<tr>
<td><strong>Business Management</strong></td>
<td><strong>Starting from €10,000</strong></td>
</tr>
<tr>
<td><span>Management of the Website keeping it up to date</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Management of texts, banners, products</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Setup of Bonuses and Promos</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Creation of Promo Materials</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Design of the appropriate Elements</span></td>
<td>&nbsp;</td>
</tr>
</tbody>
</table>
</div>
</div>`
  },
  {
    name: 'SMM Services by 360DevPro',
    slug: 'SMMServices360DevPro',
    icon: 'smm-360devpro',
    path: 'business-development/SMMServices360DevPro',
    shortDescription: 'From Social Media Market research to strategy creation and campaign management - all aspects of SMM',
    description: `
<div><img src=${require('../assets/imgs/services/SMMServices360DevPro.png').default} width="689" alt=""></div>
</br>
<p><span>In this constantly growing digital era building a strong Social Media presence is the most effective way to grow your business’ brand awareness, engage new customers and increase your website traffic.</span></p>
</br>
<p><span>With 360DevPro, you will enrich your audience with relevant followers, as we will ensure they match the demographics, interests and behaviours of your typical customers.</span><span><br></span></p>
</br>
<p><span>The appealing Social Media content will help you spread the word of mouth and referrals.</span></p>
</br>
<p><span>We are looking forward to rocking the Social Media Marketing campaigns of your business on the following platforms:</span><span><br></span></p>
<ul>
<li><span>Facebook</span></li>
<li><span>Instagram</span></li>
<li><span>Telegram</span></li>
<li><span>Twitter</span></li>
</ul>
<p><span>With a competitive Social Media strategy, exceptional content, compelling visuals and targeted ads, you will become an inseparable part of your users’ daily activity guiding them in every step of their Social Media life. Our SMM experts will build a strong relationship with your audience increasing your customers’ loyalty and driving high volumes of traffic to your website.</span></p>
`,
    pricing: `
<div>
<div>
<table><colgroup><col width="424"><col width="176"></colgroup>
<tbody>
<tr>
<td><strong>Social Media Management (SMM)</strong></td>
<td><strong>Starting from €3,000</strong></td>
</tr>
<tr>
<td><span>Market research</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Competitors’ research</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Target audience</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Visual content creation</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Social media campaign creation</span></td>
<td>&nbsp;</td>
</tr>
</tbody>
</table>
</div>
</div>    
`
  },
  {
    name: 'Animation Widget',
    slug: 'AnimationWidget',
    icon: 'animation-widget',
    path: 'business-development/AnimationWidget',
    shortDescription: 'We provide animations that cover events of the game in real-time, so users can engage more.',
    description: `
<div><img src=${require('../assets/imgs/services/AnimationWidget.png').default} width="689" alt=""></div>
</br>
<p>We provide live animations that cover events on the field in real-time, so your users can enjoy the game even without video broadcast. Our animations show everything that matters, without drawing too much attention. Integration is easy and supported by our team, while adding new sports and/or languages happens seamlessly. <br>Animations go along with insightful statistics provided for each match, both historical and live. Animations widget and statistics can be configured for a personalised look with an extensive admin settings panel.<br>Numbers:</p>
<ul>
<li>13 sports</li>
<li>22 languages</li>
<li>Up to 18% increase in engagement</li>
<li>85% users choose the page with animation</li>
<li>100% live matches covered</li>
<li>&lt;1 second delay on events</li>
</ul>
`,
    pricing: `
<p>Pricing for this service is available upon request.</p>
`
  },
  {
    name: 'Swarm API',
    slug: 'SwarmAPI',
    icon: 'swarm-api',
    path: 'business-development/SwarmAPI',
    shortDescription: 'Welcome to the SWARM API, your gateway to seamless integration of diverse BetConstruct products, especially sportsbook feeds.',
    description: `
<div><img src=${require('../assets/imgs/services/SwarmAPI.png').default} width="689" alt=""></div>
</br>
<div><p>Welcome to the SWARM API, your gateway to seamless integration of diverse Betconstruct products, especially sportsbook feeds. Designed as a robust middleware service, SWARM API empowers clients with a unified interface that not only simplifies the integration process but also enhances user session management and provides an additional cache layer mechanism for optimal performance.</p>
<h3><strong>Advantages:</strong></h3>
<ul>
<li>Unified Integration: SWARM API offers a unified interface, enabling clients to seamlessly implement and integrate various Betconstruct products, notably sportsbook feeds. This streamlines the integration process, saving valuable development time and effort.</li>
<li>Enhanced User Experience: With SWARM API, you gain improved user session management capabilities. This translates to a smoother and more personalized experience for your end-users, fostering user engagement and satisfaction.</li>
<li>Optimized Performance: Benefit from an additional cache layer mechanism embedded within SWARM API. This caching mechanism enhances data retrieval efficiency, reducing latency and bolstering overall system performance.</li>
<li>Real-time Updates: SWARM API excels at delivering real-time data updates. Stay up-to-date with the latest information, ensuring that your clients are always informed with the most current data.</li>
<li>Scalability: Designed to handle high loads, SWARM API is inherently scalable. Regardless of the user base size, you can trust that the API will seamlessly accommodate increasing demands.</li>
</ul>
<p><strong>Risks and Security Considerations:</strong></p>
<ul>
<li>Security Awareness: Users should be aware that as an API middleware, SWARM API bridges interactions between different components. Ensuring each integrated component maintains robust security measures is crucial to overall system security.</li>
<li>Connection Types: While SWARM API supports secure Websockets and HTTPS (Long Polling) connections, clients must choose the appropriate connection type based on their application's requirements and security considerations.</li>
<li>Third-party Integration: While SWARM API allows third-party clients to leverage its capabilities as a backend service, careful vetting and security checks of these third-party clients are essential to prevent potential security vulnerabilities.</li>
<li>Automated Traffic Analysis: SWARM API employs automated traffic analysis for protection against abnormal traffic patterns and API parsing. However, no automated system is foolproof, and supplementary security measures are recommended.</li>
</ul>
<p><strong>Supported Clients:</strong></p>
</br>
<p>SWARM API caters to a diverse range of clients, including:</p>
</br>
<p>Desktop Websites Mobile Websites iOS Applications Android Applications Terminal Clients Third-Party Clients At SWARM, we understand the dynamic landscape of API integration and have strived to mitigate risks while providing a host of advantages. Whether you're looking to enhance user experiences, streamline data integration, or scale your services, SWARM API stands ready to propel your applications into the future. Join us and experience the power of unified integration today.</p>
</br>
<p>Note: The risks and advantages mentioned are based on the provided description of the SWARM API. For a comprehensive assessment, it's recommended to conduct thorough security audits and integration testing.</p>
</br>
<p>SWARM API: Unveiling Customization and Efficiency in Integration</p>
</br>
<p>As you delve into the world of SWARM, you'll discover not just a middleware service, but a tailor-made solution that fits your unique integration needs. With SWARM API, we empower clients to choose between two distinct types of API solutions, each offering its own set of benefits, ensuring your integration journey is as efficient and seamless as possible.</p>
</br>
<p>Shared Nodes Integration: In the realm of SWARM API, you have the option to connect to shared nodes. This approach provides a collaborative environment, where multiple clients interact with the same nodes. While this solution fosters community interaction and the exchange of insights, there are some aspects to consider:</p>
</br>
<p><strong>Considerations:</strong></p>
</br>
<p>Resource Allocation: Resource allocation is shared among clients. Ensuring fair distribution is crucial to maintaining a balanced system.</p>
</br>
<p>Dedicated Group Integration: SWARM API also offers the unique opportunity to establish your own dedicated group. This bespoke approach ensures an integration environment that is tailored solely to your needs, providing enhanced cache calculation efficiency and a more isolated connection experience.</p>
</br>
<p><strong>Advantages:</strong></p>
<ul>
<li>Enhanced Efficiency: A dedicated group allows for more precise cache calculations, optimizing data retrieval and reducing latency. This translates to quicker responses and an improved user experience.</li>
<li>Isolated Connection: Your dedicated group operates in isolation, minimizing external interactions. This isolation enhances security and stability, fostering a controlled environment.</li>
<li>Tailored Resource Allocation: Resources are exclusively allocated to your dedicated group, allowing for optimized performance tuning and a high degree of customization.</li>
</ul>
<p><strong>Considerations</strong>:</p>
</br>
<p>Exclusive Connectivity: While a dedicated group offers advantages, it also means limited connectivity to only your dedicated nodes. Ensure that this aligns with your integration strategy.</p>
</br>
<p>Monthly Fee: A monthly fee structure, detailed in the confidentiality of our NDA, is associated with the dedicated group option. This investment is designed to support the premium features and dedicated resources provided.</p>
</br>
<p>At SWARM, we believe in empowering our clients to make choices that align with their unique requirements. Whether you opt for shared nodes to foster collaboration or a dedicated group for personalized efficiency, the SWARM API ecosystem is designed to cater to your needs. Join us in redefining integration, one custom choice at a time.</p>
</br>
<p>Note: The advantages and considerations mentioned are based on the provided description of the SWARM API. It's recommended to have detailed discussions and consultation with the SWARM team to fully understand the implications of your chosen integration solution.</p></div>
`,
    pricing: `
<p>Pricing for this service is available upon request.</p>
`
  },
  {
    name: 'Poker Operations',
    slug: 'PokerOperations',
    icon: 'poker-operations',
    path: 'business-development/PokerOperations',
    shortDescription: 'Tournament and game management, promotions, consultancy, monitoring, risk management and data analysis - all come as part of the service pack from BetConstruct’s Poker Operations team.',
    description: `
<div><img src=${require('../assets/imgs/services/PokerOperations.png').default} width="689" alt=""></div>
</br>
<p><span>BetConstruct’s Poker Operations Team offers the following services to the partners in global and local networks alike:</span></p>
</br>
<p><strong>Management of the tournaments in the global network</strong></p>
</br>
<p><span>All the partners connected to the poker global network have the opportunity to provide their players with a wide spectrum of poker tournaments at no cost. These tournaments are fully managed by the Poker Operations team, while all tournament-related costs, including the guaranteed prize pools, are covered by BetConstruct. The tournament schedule continuously grows and gets updated, giving the players a wide variety of choices.</span></p>
</br>
<p><strong>Management of the cash games in the global network</strong></p>
</br>
<p><span>All partners’ players connected to the global network have the opportunity to play in a big pool of players of the network. The cash tables of the global network are managed and monitored by BetConstruct. The rake collected from the players on the global cash tables is distributed between the partner and the provider on the basis of the agreement between the two parties signed before the launch of the game.</span></p>
</br>
<p><strong>Offering big-scale promotions to global network partners</strong></p>
</br>
<p><span>All the partners connected to the poker global network have the opportunity to participate in big-scale promotions offered by BetConstruct Poker. Their players get a chance to take part in cash and tournament leaderboards, tournament series and other poker promotions offered by our Poker team. The costs of the promotions are mostly covered by BetConstruct unless agreed otherwise before the start of the promotions. Partners have the opportunity to opt in for the promotion or cancel anytime. In addition to these global promotions, partners connected to the poker global network receive free bonus tickets or similar gifts to carry out local promotions and activations for their players.</span></p>
</br>
<p><strong>Consulting and management of partners’ local networks</strong></p>
</br>
<p><span>Partners that prefer (or are required by licensing agreements) to operate within local networks are responsible for the costs, as well as the monitoring of their players’ activities. However, we offer a full service of consulting, planning and implementing all the activities for the local network. This includes tournament planning, tournament and cash table setup, designing promotional offers, player analytics, planning of customer retention activities, design, 24/7 gameplay monitoring. The service has additional costs for partners: this is discussed and established with a separate agreement.</span></p>
</br>
<p><strong>24/7 gameplay monitoring and risk management</strong></p>
</br>
<p><span>All the partners connected to the poker global network receive 24/7 gameplay monitoring at no extra cost. The poker risk management and monitoring department takes care of all the fraudulent activities to ensure fair gameplay within the network. BetConstruct preserves the right to ban, (un)block, monitor partners’ players without partners’ confirmation. The partners are notified about such actions as soon as those are carried out.</span></p>
</br>
<p><strong>Data analytics for global network partners</strong></p>
</br>
<p><span>All the partners connected to the poker global network can request data on their players’ activities in the global network or a more detailed analysis based on specified criteria. For the sake of confidentiality, an analytics report provided to one partner does not disclose any of the data related to other partners’ activities.</span></p>
`,
    pricing: `
<p>Pricing for this service is available upon request.</p>
`
  },
  {
    name: 'Catalyst Law Services',
    slug: 'CatalystLawServices',
    icon: 'catalyst-law-services',
    path: 'business-development/CatalystLawServices',
    shortDescription: 'Thrive in the legal world with integrity, compliance, and success.',
    description: `
<div><img src=${require('../assets/imgs/services/CatalystLaw.png').default} width="689" alt=""></div>
</br>
<p><strong>What we offer</strong></p>
</br>
<p>Catalysts is your legal partner, dedicated to fueling business growth and success in a dynamic, regulated landscape. It provides specialised services tailored to diverse industries' unique legal and regulatory needs.</p>
</br>
<p>Discover the legal world with the help of our tailored solutions and diverse industry expertise with our unwavering integrity, transparency, and responsive service. </p>
</br>
<p><strong>Included services:</strong></p>
<ul>
  <li><strong>Banking Services: </strong>Multi-currency accounts, swift setup, and specialised solutions for various industries.</li>
  <li><strong>Company Formation Services: </strong>Tailored solutions for seamless growth.</li>
  <li><strong>International Licensing Services: </strong>Streamlined VASP licensing across regions.</li>
  <li><strong>Services for Financial Institutions: </strong>Tailored legal services ensuring success in the financial landscape.</li>
  <li><strong>Legal Services for Crypto Companies: </strong>Comprehensive legal support for crypto businesses.</li>
  <li><strong>Other Services: </strong>Diverse offerings for enhanced business prospects.</li>
</ul>
`,
    pricing: `
<div>
<table>
<tbody>
<tr>
<td>
<p><br>ACCOUNT DETAILS</p>
</td>
<td>
<p>OPENING TIME</p>
</td>
<td>
<p>FEES</p>
</td>
</tr>
<tr>
<td>
<p>Monthly maintenance 25 EUR<br><br>Incoming payments<br>SEPA (EUR from EEA countries)<br>0.15% (Min €10, Max €50)<br><br>International 0.25% (Min €25, Max<br>€120)<br><br>Outgoing payments<br>SEPA (EUR to EEA countries) €10<br>International 0.25% (Min €25, Max<br>€80)<br><br>Card order €100<br>Card maintenance €15</p>
</td>
<td>
<p>7-12 days</p>
</td>
<td>
<p>5000 EUR</p>
</td>
</tr>
</tbody>
</table>
</div>`
  },
  {
    name: 'Bet Easy',
    slug: 'BetEasy',
    icon: 'bet-easy',
    path: 'business-development/BetEasy',
    shortDescription: 'Bet Easy - a cross-platform solution for seamless mobile app creation. With a unified UI/UX and streamlined integration options, partners can deliver enhanced user experiences on iOS and Android devices. Bet Easy include rapid development, gamification and personalisation features for users.',
    description: `
<div><img src=${require('../assets/imgs/services/BetEasy.png').default} width="689" alt=""></div>
</br>
<p><strong>Bet Easy</strong> is a cross-platform solution that simplifies mobile application development for betting and gambling. Unlike traditional approaches, it unifies UI/UX, integrates Casino & Sportsbook functionalities, and enhances user experiences across iOS and Android platforms.</p>
</br>
<p><strong>CASINO FUNCTIONALITIES</strong></p>
<ul>
<li>100+ Game Providers</li>
<li>Slots and Live Dealer Games</li>
<li>Tournaments</li>
</ul>
<p><strong>SPORTSBOOK FUNCTIONALITIES</strong></p>
<ul>
<li>All BetConstruct sportsbook related products, including CashOut, BetBuilder, Statistics, Video broadcasts</li>
<li>Sportsbook bonuses</li>
<li>Sportsbook tournaments</li>
</ul>
<p><strong>KEY FEATURES</strong></p>
<ul>
<li><strong>Flutter Integration</strong>: Seamless unified user experiences across various platforms.</li>
</ul>
<ul>
<li><strong>Engaging Gamification</strong>: Enhancing user attention and enthusiasm through interactive features.</li>
</ul>
<ul>
<li><strong>Quick Launch Process</strong>: Running the MVP-stage app in 4-5 weeks.</li>
</ul>
<ul>
<li><strong>Integrated Command Functionality</strong>: Easy integration of various features and tools, including Business Dashboard, Recommender, Chats, and Socialisation</li>
</ul>
<ul>
<li><strong>Real Money Games</strong>: Immersing users in authentic gaming adventures.</li>
</ul>
`,
    pricing: `
<p>Pricing for this service is available upon request.</p>
`
  },
  {
    name: 'BBG Services',
    slug: 'BBGServices',
    icon: 'bbg',
    path: 'business-development/BBGServices',
    shortDescription: 'Have your solid and resolute position in the financial and legal sectors with BBG services.',
    description: `
<div><img src=${require('../assets/imgs/services/BBGServices.png').default} width="689" alt=""></div>
</br>
<p>BBG Services provides a handy package of services to boost the professional level of businesses. In its finance section are services such as money transfers, cryptocurrency transfers, merchant services, and cost management, among others.</p>
</br>
<p>BBG provides licenses for businesses that deal with virtual currencies, standard payment institution license/major payment institution license, and money service operator license to enhance their legal standing. All of the above are paired with all of the appropriate legal documentation for your company, including a shareholder agreement, a founder agreement, a joint venture agreement, a development agreement, legal opinion, etc.</p>
<h3>Financial licenses</h3>
<p>Services</p>
<ul>
<li>Electronic money institution (Lithuania, United Kingdom): Most popular services offered by EMIs:</li>
</ul>
<ul>
<li>Personal accounts with IBAN Money transfers<br>Expense management</li>
<li>Business account with IBAN Cryptocurrency operations Payment cards<br>Merchant services</li>
</ul>
<p>Virtual currency service provider license (Estonia, Lithuania, Cayman Islands, etc) Companies that deal with virtual currencies can apply for one license which has two main activities:</p>
<ul>
<li>
<p>Providers of a service of exchanging a virtual currency against a fiat currency</p>
</li>
<li>
<p>Providers of a virtual currency wallet service<br>Standard payment institution license/Major payment institution license (Singapore)<br>One class of license has seven different types of activities:</p>
</li>
</ul>
<ul>
<li>
<p>Account issuance</p>
</li>
<li>
<p>Domestic money transfer</p>
</li>
<li>
<p>Cross-border money transfer</p>
</li>
<li>
<p>Merchant acquisition</p>
</li>
<li>
<p>E-money issuance</p>
</li>
<li>
<p>Digital payment tokens (“crypto”) dealing and exchange</p>
</li>
<li>
<p>Money changing</p>
</li>
</ul>
<p>Money Service Operator License (Hong Kong) A money service means a money-changing service or a remittance service.</p>
<h3>Legal Documents</h3>
<p>Document types</p>
<ul>
<li>
<p>SAFT</p>
</li>
<li>
<p>Shareholder agreement</p>
</li>
<li>
<p>Founder agreement</p>
</li>
<li>
<p>AML policy</p>
</li>
<li>
<p>Terms of service</p>
</li>
<li>
<p>Privacy Policy</p>
</li>
<li>
<p>Joint Venture agreement</p>
</li>
<li>
<p>Development agreement</p>
</li>
<li>
<p>Legal opinion</p>
Company incorporation (limited liability, trust, foundation)</li>
</ul>
<h3>Jurisdictions</h3>
<ul>
<li>
<p>BVI</p>
</li>
<li>
<p>Hong Kong</p>
</li>
<li>
<p>Singapore</p>
</li>
<li>
<p>UK</p>
</li>
<li>
<p>Estonia Digital</p>
</li>
<li>
<p>Physical</p>
</li>
<li>
<p>Switzerland</p>
</li>
<li>
<p>Lichtenstein</p>
</li>
<li>
<p>Cyprus</p>
</li>
<li>
<p>Cayman Islands</p>
</li>
<li>
<p>Panama</p>
</li>
<li>
<p>Seychelles</p>
</li>
<li>
<p>China</p>
</li>
</ul>
`,
    pricing: `
<div>
<div>
<table cellpadding="5">
<tbody>
<tr>
<td>
<div>
<div>
<p>Services</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>Cost</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Electronic money institution (Lithuania, United Kingdom): Most popular services offered by EMIs:</p>
</div>
</div>
<div>
<div>
<p>Personal accounts with IBAN Money transfers<br> Expense management Business account with IBAN</p>
</div>
<div>
<p>Cryptocurrency operations Payment cards<br> Merchant services</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>From 90,000</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Virtual currency service provider license (Estonia, Lithuania, Cayman Islands etc) Companies that deal with virtual currencies can apply for one license which has two main activities:</p>
<ul>
<li>Providers of a service of exchanging a virtual currency against a fiat currency</li>
<li>Providers of a virtual currency wallet service</li>
</ul>
</div>
</div>
</td>
<td>
<div>
<div>
<p>From 30,000</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Standard payment institution license/Major payment institution license (Singapore) One class of license has seven different types of activities:● Account issuance</p>
<ul>
<li>
<p>Domestic money transfer</p>
</li>
<li>
<p>Cross-border money transfer</p>
</li>
<li>
<p>Merchant acquisition</p>
</li>
<li>
<p>E-money issuance</p>
</li>
<li>
<p>Digital payment tokens (“crypto”) dealing and exchange</p>
</li>
<li>
<p>Money changing</p>
</li>
</ul>
</div>
</div>
</td>
<td>
<div>
<div>
<p>From 90,000</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Money Service Operator License (Hong Kong) A money service means a money changing service or a remittance service.</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>From 90,000</p>
</div>
</div>
</td>
</tr>
</tbody>
</table>
</div>
<div>
<div>
<div>
<div>
</br>
<p>Legal documents</p>
</br>
</div>
</div>
<table cellpadding="5">
<tbody>
<tr>
<td>
<div>
<div>
<p>Document types</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>Price from</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>SAFT</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>5,500</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Shareholder agreement</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>6,800</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Founder agreement</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>5,800</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>AML policy</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>5,600</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Terms of service</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>5,400</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Privacy Policy</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>4,800</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Joint Venture agreement</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>5,500</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Development agreement</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>4,400</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Legal opinion</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>From 15,000</p>
</div>
</div>
</td>
</tr>
</tbody>
</table>
<div>
<div>
</br>
<p>Company incorporation (limited liability, trust, foundation)</p>
</br>
</div>
</div>
<table border="1" cellspacing="2" cellpadding="5">
<tbody>
<tr>
<td>
<div>
<div>
<p>Jurisdictions</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>Price</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>BVI</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>9500</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Hong Kong</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>13200</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Singapore</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>13200</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>UK</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>4250</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Estonia</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>Digital - 4250 Physical - 5800</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Switzerland</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>17600</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Lichtenstein</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>17600</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Cyprus</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>11000</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Cayman Islands</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>9900</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Panama</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>13200</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>Seychelles</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>13200</p>
</div>
</div>
</td>
</tr>
<tr>
<td>
<div>
<div>
<p>China</p>
</div>
</div>
</td>
<td>
<div>
<div>
<p>9050</p>
</div>
</div>
</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
`
  },
  {
    name: 'Passionate',
    slug: 'Passionate',
    icon: 'passionate',
    path: 'business-development/Passionate',
    shortDescription: 'Stand out with thrilling colors and a distinctive brand!',
    description: `
<div><img src=${require('../assets/imgs/services/Passionate.png').default} width="689" alt=""></div>
</br>
<p>Passionate is a creative design agency specialising in branding, graphic design, user experience consulting, and user interface design for software companies, websites and apps. At Passionate we pride ourselves on our meticulous attention to detail, speed of delivery and the genuine advice we provide throughout the process! Thanks to our senior experts’ broad set of expertise, we are able to plan and work on multiple aspects of your project simultaneously optimising the overall timeline and cost.</p>
</br>
<p><strong>Branding and Artwork design</strong></p>
</br>
<p>Our branding and artwork services start with a discovery phase: through discussions with you we create a moodboard to help us identify the direction and style the designs should go in! We then proceed to creating sketches and producing the first draft(s) of the design(s). Once these are ready we will share them with you for review. The rest of the process is then allocated to implementing edits and producing further concepts based on your feedback, until the designs are spot-on!</p>
</br>
<p><strong>Digital marketing materials and graphics design</strong></p>
</br>
<p>Our marketing material design services start with a discovery phase: through discussions with you we strive to nail down the message that should be communicated and the contents that will be used. We then proceed to create the first draft(s) of the design(s) and share them with you for review. The rest of the process is then allocated to implementing edits and producing further concepts based on your feedback, until the designs are spot-on!</p>
</br>
<p><strong>Offline marketing materials and print design</strong></p>
</br>
<p>Our offline marketing material design services start with a discovery phase: through discussions with you we strive to nail down the message that should be communicated and the contents that will be used. We then proceed to create the first draft(s) of the design(s) and share them with you for review. The rest of the process is then allocated to implementing edits and producing further concepts based on your feedback, until the designs are spot on! Our print design services also include support all the way until the printing process starts, including:</p>
<ul>
<li>Ensuring all design elements are in CMYK</li>
<li>Ensuring the design elements meet the requirements provided by the printing company (including specific requirements such as gold print)</li>
<li>Ensuring the files are formatted to the printing company’s preferences<br><br></li>
</ul>
`,
    pricing: `
<div>
<p><strong>Branding and Artwork design</strong></p>
</br>
<div>
<table><colgroup><col width="639"><col width="143"></colgroup>
<tbody>
<tr>
<td>Service details</td>
<td>Price</td>
</tr>
<tr>
<td>Logo design (with up to 8 concepts and up to 3 revisions)</td>
<td>€1,000</td>
</tr>
<tr>
<td>Branding guidelines/Brandbook</td>
<td>€800</td>
</tr>
<tr>
<td>Logo Use Guidelines such as minimum size, background colours etc.</td>
<td>&nbsp;</td>
</tr>
<tr>
<td>Brand Fonts and Guidelines on Use</td>
<td>&nbsp;</td>
</tr>
<tr>
<td>Brand Colour Palette With Codes</td>
<td>&nbsp;</td>
</tr>
<tr>
<td>Website or App Icon design pack of 10 (2 style-setter concepts to choose from and up to 2 revisions)</td>
<td>€700 - €2,500</td>
</tr>
<tr>
<td>Brand Mascot design, (up to 4 concepts and 2 revisions)</td>
<td>€1,500</td>
</tr>
<tr>
<td>Illustration design (2 concept sketches and 2 revisions)</td>
<td>€1,500 -&nbsp;€2,500</td>
</tr>
</tbody>
</table>
</div>
</br>
<p><strong>Digital marketing materials and graphics design</strong></p>
</br>
<div>
<table><colgroup><col width="639"><col width="143"></colgroup>
<tbody>
<tr>
<td>Service details&nbsp;</td>
<td>Price</td>
</tr>
<tr>
<td>Social media or PPC advert design, up to 3 concepts and 2 revisions</td>
<td>€500</td>
</tr>
<tr>
<td>Social media or PPC banner design, up to 3 concepts and 2 revisions</td>
<td>€550</td>
</tr>
<tr>
<td>Illustration design, 2 concept sketches and 2 revisions</td>
<td>€1,500 - €2,500</td>
</tr>
<tr>
<td>HTML email signature design with html code, up to 3 concepts and 2 revisions, contacts adjusted for up to 5 people</td>
<td>€700</td>
</tr>
<tr>
<td>Promotional pdf flyer design, up to 2 concepts and 2 revisions, per side</td>
<td>€650</td>
</tr>
<tr>
<td>Animations (excluding person animations) per 10 seconds&nbsp;</td>
<td>€600 - €800</td>
</tr>
<tr>
<td>Email template design, up to 2 concepts and 2 revisions</td>
<td>€700</td>
</tr>
<tr>
<td>Email template build (with hubspot, mailchimp, mailer lite template builder)</td>
<td>€600</td>
</tr>
</tbody>
</table>
</div>
</br>
<p><strong>Offline marketing materials and print design</strong></p>
</br>
<div>
<table><colgroup><col width="639"><col width="143"></colgroup>
<tbody>
<tr>
<td>Service details&nbsp;</td>
<td>Price</td>
</tr>
<tr>
<td>Powerpoint template design based on branding, up to 2 concepts and 2 revisions, per slide:</td>
<td>€250</td>
</tr>
<tr>
<td>Business card design (double-sided), up to 3 concepts and 2 revisions, contacts adjusted for up to 5 people</td>
<td>€700</td>
</tr>
<tr>
<td>Headed template design, up to 3 concepts and 2 revisions</td>
<td>€600</td>
</tr>
<tr>
<td>Flyer design, up to 2 concepts and 2 revisions, per side</td>
<td>€650</td>
</tr>
<tr>
<td>Brochure design (6+ sides), up to 2 concepts and 2 revisions, per side:</td>
<td>€400</td>
</tr>
<tr>
<td>Poster design, up to 3 concepts and 2 revisions</td>
<td>€1,000</td>
</tr>
<tr>
<td>Pop-up, roll-up, hanging or similar banner design, up to 2 concepts and 2 revisions</td>
<td>€1,000</td>
</tr>
</tbody>
</table>
</div>
</div>
`
  },
  {
    name: 'Business Dashboard',
    slug: 'BusinessDashboard',
    icon: 'business-dashboard',
    path: 'business-development/BusinessDashboard',
    shortDescription: 'Improve professional efficiency and reveal current business indicators with Dashboard!',
    description: `
<div><img src=${require('../assets/imgs/services/BusinessDashboard.png').default} width="689" alt=""></div>
</br>
<p>With all major company indicators and data, Dashboard in Tableau is the best platform which will ease your professional working flow, pushing it to a new level.</p>
</br>
<p>This can serve as a great tool to unveil all the key business metrics and dynamic results. You will have the ability to customise the dashboard to fit your needs and also take highly qualified consulting and training sessions with SoftConstruct analysts. Staying available 24/7, Business Dashboard delivers only verified data by the SoftConstruct DataPlatform team. This awesome instrument supplies everything that you may need in your business workflow including automated data reporting in PDF and PPT formats sent to your email, data uploading in PDF and PPT formats, automatic updates, custom alerts if any of the important indicators deviate from the normal values, availability on mobile and many more.</p>
<p><strong>Learn more about</strong></p>
<ul>
<li>What data the dashboard includes</li>
<li>Consulting and training by SoftConstruct analysts</li>
<li>Pricing</li>
</ul>
<h2><strong>What data does the dashboard include?</strong></h2>
<h3><strong>Finance</strong></h3>
<ul>
<li>Deposits</li>
<li>Withdrawals</li>
<li>Additional metrics based on Deposits & Withdrawals</li>
<li>Payment systems</li>
</ul>
<h3><strong>Bets</strong></h3>
<ul>
<li>GGR, GGR %, and Turnover by Sportsbook & Casino</li>
<li>Bets count by Sportsbook & Casino</li>
<li>Number of active clients</li>
<li>MAX win by SportsBook & Casino</li>
<li>MAX and AVG bet by SportsBook & Casino</li>
<li>Other metrics</li>
</ul>
<h3><strong>Player Acquisition</strong></h3>
<ul>
<li>Number of registrations</li>
<li>% of players who have made a deposit on the day of registration</li>
<li>% of players who have played on the day of registration</li>
<li>Cohort Analysis (% of players who continue to play after registration)</li>
<li>RFM Analysis. Different groups: Number of bets vs How much has passed since the last bet</li>
</ul>
<h3><strong>Web-analytics</strong></h3>
<ul>
<li>Number of sessions by traffic sources</li>
<li>Number of registrations by traffic sources</li>
<li>Conversion Rate (CR %) from traffic to registrations</li>
<li>Conversion Rate (CR %) from registrations to FTD</li>
<li>Conversion Rate (CR %) from registrations to bets</li>
<li>Funnel-Table which shows the numbers of sessions, registrations, SUM of deposits, SUM of bets, etc</li>
</ul>
<h4><strong>Detailed analytics of Casino Games & Sportsbook</strong></h4>
<ul>
<li>GGR, Bonus Cost, NGR</li>
<li>Detailed information by Sports, Regions, Matches</li>
<li>Detailed information by Products, Providers, Games</li>
<li>Cohort Analysis by Casino & Sportsbook Clients</li>
</ul>
<h3><strong>Custom dashboard</strong></h3>
<p>Metrics that are not included in the main dashboard, but are considered important for your business.</p>
<h3><strong>Consulting and training by SoftConstruct analysts</strong></h3>
<p>In addition to accessing the dashboard in Tableau, you can also use consulting and training services from SoftConstruct analysts:</p>
<ul>
<li>Creating custom dashboards in Tableau</li>
<li>Teaching your employees how to work with data and how to get important insights</li>
<li>Consulting on any issues related to analytics</li>
</ul>
`,
    pricing: `
<div>
<h3><strong>Basic (€ 400 per month)</strong></h3>
<ul>
<li>Access to the main Tableau dashboard with key metrics</li>
<li>Access to the dashboard for 2 employees</li>
</ul>
<h3><strong>Advanced (€ 800 per month)</strong></h3>
<ul>
<li>Access to the main Tableau dashboard with key metrics</li>
<li>2 additional tabs in the dashboard with extended information about Casino and Sportsbook</li>
<li>Web analytics. Effectiveness of advertising channels</li>
<li>5 hours a month of SoftConstruct analysts for customizing the main dashboard.</li>
<li>Access to the dashboard for 5 employees</li>
</ul>
<h3><strong>Premium (€ 1600 per month)</strong></h3>
<ul>
<li>Access to the main Tableau dashboard with key metrics</li>
<li>2 additional tabs in the dashboard with extended information about Casino and Sportsbook</li>
<li>Web analytics. Effectiveness of advertising channels</li>
<li>20 hours a month of SoftConstruct analysts, which can be spent on consulting, creation, and support of custom analytics.</li>
<li>Access to the dashboard for 7 employees</li>
</ul>
</div>`
  },
  {
    name: 'Business Lean-Agile Transformation',
    slug: 'BusinessLeanAgileTransformation',
    icon: 'business-lean-agile-transformation',
    path: 'business-development/BusinessLeanAgileTransformation',
    shortDescription: 'We offer to improve business performance, maximize survival, create value-added products or servicess',
    description: `
<div><img src=${require('../assets/imgs/services/BusinessLeanAgileTransformation.png').default} width="689" alt=""></div>
</br>
<p>If you need to adopt a rapidly changing marketplace, deliver need-covering results faster, acquire and retain more customers, reduce wastes, we are here to build motivating corporate culture and reach the transformation.<br>It implies dedicated cooperation of changing company character by mixing Lean-Agile culture with digital solutions to help get more value with fewer resources.</p>
</br>
<p>Business Lean-Agile Transformation is a full package that includes different sub-services such as:</p>
<ul>
<li>Dedicated Project Manager/Coach</li>
<li>Management Training &Consulting</li>
<li>Lean-Agile Tools Full Coverage</li>
<li>Staff Training</li>
<li>Business Process Automation & Optimization</li>
</ul>
<p>Each of the sub-services mentioned above has its crucial role for the final result, but if you need to get some of them separately, you can look through the "Lean-Agile Training & Consulting" and the "Digital Management Tools Integration" services, ;which are also Packaged Services but let you get sub-services from there separately.</p>
</br>
<p>To better estimate the value of each of the sub-services, it is better to inspect them separately:</p>
</br>
<p><strong>Dedicated Project Manager/Coach</strong> </br>To deliver immediate business results, it is important to have a dedicated Project Manager who, constantly being with you, will meet your business needs and tailor direct solutions. This will help you accelerate the transformation process and take big steps forward.</p>
</br>
<p><strong>Management Consulting & Training</strong> </br>We believe that management consulting is more than just an advice-giving process and includes a wide range of actions that will cover lots of points via inspection, adaptation, and implementation processes. Given the knowledge and skills that every manager should possess, we believe that the role of Management Training is essential for achieving higher value from Management Consulting.</p>
</br>
<p><strong>Lean-Agile Tools Full Coverage</strong> </br>Each digital tool is aimed to facilitate and simplify the workflows by providing additional functions. Lean-Agile tools (such as Atlassian tools (Jira, Confluence, Plans), CRM tools, PeopleForce, etc.) not only optimize work but also provide additional opportunities, especially for managerial roles, to be able to track, control, and analyze significant and minor issues. Our services include its' implementation, support and training, that will align with HR Management, Project and Product Management, and overall Management Processes.<strong><br></strong></p>
</br>
<p><strong>Staff Training</strong> </br>Regardless of the industry, yօu need to be ensured that your staff has needed knowledge and skills, is in line with the culture that will help them keep up with the times. It is undeniable that by allowing the staff to learn and grow in your company, you increase the chance to retain those employees and create a better-qualified workforce that will benefit your business in the future.<br>We deliver two types of Staff Training, such as: </p>
</br>
<p><strong>General Training</strong> </br>This type of training will give your employees practical and theoretical skills to collaborate with a Lean-Agile mindset. It will help them optimize their performance, standardize and facilitate processes, create a simple system for generating value that matches the company's culture and vision.</p>
</br>
<p>Specified Domain TrainingThis type of training has a more specific and direct focus. We offer a variety of options for resolving direct issues.</p>
<ul>
<li>Business Management</li>
<li>Product Management</li>
<li>Project Management</li>
<li>Sales Management</li>
<li>Quality Management</li>
<li>Financial Management</li>
<li>Marketing Plan A-Z</li>
<li>HR Management</li>
</ul>
<p><strong>Business Process Automation & Optimization</strong></p>
</br>
<p>There is no doubt that every business process matters. And the organization can reach increase its performance when its processes are as efficient and effective as possible. We will help you identify all the major processes that could be automated and standardized, then prepare technical automation via workflow and create a guide for their utilization and audit.</p>
`,
    pricing: `
<div>
<p>Our services are very diversified and designed for different companies, so it is hard to specify prices. The final price is based on some contract terms, including:</p>
<ul>
<li>Company industry</li>
<li>Number of participants</li>
<li>Quantity of processes</li>
<li>Amount of our specialists collaborating with you</li>
<li>Collaboration format</li>
</ul>
</div>
`
  },
  {
    name: 'Digital Management Tools Integration',
    slug: 'DigitalManagementToolsIntegration',
    icon: 'digital-management-tools-integration',
    path: 'business-development/DigitalManagementToolsIntegration',
    shortDescription: 'We offer to optimize your flows, get digital solutions for standardization and decrease undue work',
    description: `
<div><img src=${require('../assets/imgs/services/DigitalManagementToolsIntegration.png').default} width="689" alt=""></div>
</br>
<p>Suppose you need to overcome some challenges like Team-Workflow-Task Management, Controlled Budgeting, Resource Management, or even Data Management.<br>In that case, we are here to help you to see-through, automate and manage your complex processes with our simple solutions.</p>
</br>
<p>Digital Management Tools Integration service is a complete package consisting of different sub-services such as:</p>
<ul>
<li>Lean-Agile Tools Implementation</li>
<li>Lean-Agile Tools Training</li>
<li>Business Process Automation & Optimization</li>
<li>Lean-Agile Tools Training Full Coverage</li>
<li>Complete Management Tools Implementation</li>
<li>Management Tools Training Full Coverage</li>
</ul>
<p>Each of the sub-services mentioned above could be sold separately. In addition to the fact that the acquisition of the Digital Management Tools Integration package implies a more valuable result, it also requires a more budget-friendly / cost-effective investment.</p>
</br>
<p>To better estimate the value of each of the services, it is better to inspect them separately:</p>
</br>
<p><strong>Lean-Agile Tools Implementation</strong><strong><br></strong>In general, there are many digital tools for tracking, analyzing, and managing your work. But trends and analysis at the time ranked Atlassian as one of the best tools to provide solutions to help you better organize your work, no matter your organization's industry. But the market is too big; there are other tools that could be used. Adding to this the rich experience of our professionals, we offer to implement Lean-Agile Tools in your company, helping to have more structured, optimized, and transparent processes.</p>
</br>
<p><strong>Lean-Agile Tools Training</strong><strong><br></strong>In addition to implementing any tool in your company, you need key people who know them in detail and can use them to the company's best advantage to get the most out of it. It's the same with Lean-Agile Tools: we offer sufficient training for your specific employees to meet your requirements concerning mentioned tools.</p>
</br>
<p><strong>Business Process Automation & Optimization</strong><strong><br></strong>There is no doubt that every business process matters. And the organization can reach increase its performance when its processes are as efficient and effective as possible. We will help you identify all the major processes that could be automated and standardized, then prepare technical automation via workflow and create a guide for their utilization and audit.</p>
</br>
<p><strong>Lean-Agile Tools Training Full Coverage</strong><strong><br></strong>Although we note the importance of specific employees who have a deep knowledge of Lean-Agile tools, it is also essential to understand the importance of each employee's level of knowledge and skills in using these tools. Every employee should have a basic understanding of the tools used by the company. It simplifies the work, definitely increases the quality and productivity. This session includes in-depth training for specific employees and basic training for other employees using that tools.</p>
</br>
<p><strong>Complete Management Tools Implementation<br></strong>Each digital tool is aimed to facilitate and simplify the workflows by providing additional functions. Management tools not only optimize work, but also provide additional opportunities, especially for managerial roles, to be able to track, control and analyze significant and minor issues. Our services include the implementation of Managerial Digital Tools in your company that will align with HR Management, Project and Product Management, and overall Management Processes.</p>
</br>
<p><strong>Management Tools Training Full Coverage<br></strong>Given each employee's crucial role and contribution to the company's performance, in addition to digital tools integration, it is essential that every employee who uses these tools, regardless of position and its level, can master them as best as possible. In this context, our "Management Tools Training Full Coverage" session can fully meet your needs.</p>
</br>
<p><strong>Sub-Services</strong></p>
</br>
<div>
<table><colgroup><col width="400px"><col width="110px"><col width="110px"><col width="110px"></colgroup>
<thead>
<tr>
<th>
<div>Service</div>
</th>
<th>
<div>Duration</div>
</th>
<th>
<div>Category</div>
</th>
<th>
<div>Type</div>
</th>
</tr>
</thead>
<tbody>
<tr>
<td>Lean-Agile Tools Implementation</td>
<td>Short Term</td>
<td>Digitalization</td>
<td>Online / Offline</td>
</tr>
<tr>
<td>Lean-Agile Tools Training</td>
<td>Short Term</td>
<td>Training</td>
<td>Online / Offline</td>
</tr>
<tr>
<td>Business Process Automation & Optimization</td>
<td>Long Term</td>
<td>Transformation</td>
<td>Offline</td>
</tr>
<tr>
<td>Lean-Agile Tools Training Full Coverage</td>
<td>Long Term</td>
<td>Training</td>
<td>Online / Offline</td>
</tr>
<tr>
<td>Complete Management Tools Implementation</td>
<td>Long Term</td>
<td>Transformation</td>
<td>Offline</td>
</tr>
<tr>
<td>Management Tools Training Full Coverage</td>
<td>Short Term</td>
<td>Training</td>
<td>Online / Offline</td>
</tr>
</tbody>
</table>
</div>
`,
    pricing: `
<div>
<p>Our services are very diversified and designed for different companies, so it is hard to specify prices. The final price is based on some contract terms, including:</p>
<ul>
<li>Company industry</li>
<li>Number of participants</li>
<li>Quantity of processes</li>
<li>Amount of our specialists collaborating with you</li>
<li>Collaboration format</li>
</ul>
</div>
`
  },
  {
    name: 'Lean-Agile Training & Consulting',
    slug: 'LeanAgileTrainingConsulting',
    icon: 'lean-agile-training-consulting',
    path: 'business-development/LeanAgileTrainingConsulting',
    shortDescription: 'This session will let you increase your practical and theoretical skills in Management and not only',
    description: `
<div><img src=${require('../assets/imgs/services/LeanAgileTrainingConsulting.png').default} width="689" alt=""></div>
</br>
<p><span>Immense knowledge and practical skills of Management play an important role in shaping the culture of an organization as it needs to be repeated stimulus․ Here we offer you to do your next step with us to solve your challenges, accomplish your goals, efficiently operate your business, soundly organize the structures, etc. Lean-Agile Training & Consulting sessions provide knowledge that will cover all your managerial and organizational requirements.</span></p>
</br>
<p><span>Lean-Agile Training & Consulting is a complete package consisting of different sub-services such as:</span></p>
<ul>
<li><span>Management Training</span></li>
<li><span>Management Consulting</span></li>
<li><span>Staff Training</span></li>
<li><span>Dedicated Coach</span></li>
</ul>
<p><span>Each of the services mentioned above could be sold separately, except the Management Consulting. Given the knowledge and skills that every manager should possess, we believe that the role of Management Training is essential for achieving higher value from Management Consulting.</span></p>
</br>
<p><span>In addition to the fact that the acquisition of the Lean-Agile Training & Consulting package implies a more valuable result, it also requires a more budget-friendly / cost-effective investment.</span></p>
</br>
<p><span>To better estimate the value of each of the sub-services, it is better to inspect them separately:</span></p>
</br>
<p><strong>Management Training</strong></p>
</br>
<p><span>Overall the most crucial factor for the business is Management because no business runs on itself. So our </span><span>Management training focuses on improving and increasing the theoretical and practical knowledge and skills to help managers lead performance more effectively.</span></p>
</br>
<p><strong>Management Consulting</strong></p>
</br>
<p><span>We believe that management consulting is more than just an advice-giving process and includes a wide range of actions that will cover lots of points, via inspection, adaptation, and implementation processes.</span></p>
</br>
<p><strong>Staff Training</strong></p>
</br>
<p><span>Regardless of the industry, yօu need to be ensured that your staff has needed knowledge and skills, is in line with the culture that will help them keep up with the times. It is undeniable that by allowing the staff to learn and grow in your company, you increase the chance to retain those employees and create a better-qualified workforce that will benefit your business in the future.</span></p>
</br>
<p><span>We deliver two types of Staff Training, such as:</span></p>
</br>
<p><strong>General Training</strong></p>
</br>
<p><span>This type of training will give your employees practical and theoretical skills to collaborate with a Lean-Agile mindset. It will help them optimize their performance, standardize and facilitate processes, create a simple system for generating value that matches the company's culture and vision.</span></p>
</br>
<p><strong>Specified Domain Training</strong></p>
</br>
<p><span>This type of training has a more specific and direct focus. We offer a variety of options for resolving direct issues.</span></p>
<ul>
<li><span>Business Management</span></li>
<li><span>Product Management</span></li>
<li><span>Project Management</span></li>
<li><span>Sales Management</span></li>
<li><span>Quality Management</span></li>
<li><span>Financial Management</span></li>
<li><span>Marketing Plan A-Z</span></li>
<li><span>HR Management</span></li>
</ul>
<p><strong>Dedicated Coach</strong></p>
</br>
<p><span>To get a more effective and prominent result, it is important to have a dedicated coach who, constantly being with you, will be able to deeply inspect and analyze your company and offer more accurate solutions. This will help you make more precise improvements and move forward in larger, faster steps.</span></p>
</br>
<div>
<table><colgroup><col width="275"><col width="90"><col width="116"><col width="131"></colgroup>
<tbody>
<tr>
<td><strong>Service</strong></td>
<td><strong>Duration</strong></td>
<td><strong>Category</strong></td>
<td><strong>Type</strong></td>
</tr>
<tr>
<td><span>Management Training</span></td>
<td><span>Short Term</span></td>
<td><span>Training</span></td>
<td><span>Online / Offline</span></td>
</tr>
<tr>
<td><span>Management Consulting</span></td>
<td><span>Short Term</span></td>
<td><span>Consulting</span></td>
<td><span>Online / Offline</span></td>
</tr>
<tr>
<td><span>Staff Training</span></td>
<td><span>Long Term</span></td>
<td><span>Training</span></td>
<td><span>Online / Offline</span></td>
</tr>
<tr>
<td><span>Dedicated Coach</span></td>
<td><span>Long Term</span></td>
<td><span>Consulting</span></td>
<td><span>Online / Offline</span></td>
</tr>
</tbody>
</table>
</div>
`,
    pricing: `
<div>
<div>
<table><colgroup><col width="416"><col width="184"></colgroup>
<tbody>
<tr>
<td><strong>Service</strong></td>
<td><strong>Price</strong></td>
</tr>
<tr>
<td><span>Management Training</span></td>
<td><span>€ 1.900</span></td>
</tr>
<tr>
<td><span>Management Consulting</span></td>
<td><span>€ 3.300</span></td>
</tr>
<tr>
<td><span>Management Training & Consulting</span></td>
<td><span>€ 5.000</span></td>
</tr>
</tbody>
</table>
</div>
<p><span><br></span><span>Our services are very diversified and designed for different companies, so it is hard to specify prices. The final price for </span><span>Staff training</span><span> and </span><span>Dedicated Coach</span><span> services is based on some contract terms, including:</span></p>
<ul>
<li><span>Company industry</span></li>
<li><span>Number participants</span></li>
<li><span>Quantity of processes</span></li>
<li><span>Amount of our specialists collaborating with you</span></li>
<li><span>Collaboration format</span></li>
</ul>
</div>`
  },
  //-------------------------------------------------------> Law
  {
    name: 'Licensing Services',
    slug: 'licensingServices',
    icon: 'licensing',
    path: 'law/LicensingServices',
    shortDescription: `All about the licensing process via BetConstruct and the service fees for your iGaming operation`,
    description: `
<div><img src=${require('../assets/imgs/services/Licensing.png').default} width="689" alt=""></div>
<br>
<p>BetConstruct’s Licensing services, available via the SpringBME console, cover such areas as an iGaming company setup in Curaçao and/or in Cyprus, as well as the entire application process for the licence. Let’s take a look at each of these.</p>
<br>
<p>All the fees are payable to BetConstruct for the Licensing services: we then take care of the rest, in terms of handling setup and management stages, as well as any issues that may occur along the way.</p>
<br>
<p>To get started with the licencing process for your iGaming operation, you will to have prepared the following list of required documents:</p>
<ul>
<li>a notarised copy of your passport; </li>
<li>an original utility bill </li>
<li>resume / CV of the UBO </li>
<li>an original certificate of good conduct </li>
<li>an original reference letter from your bank </li>
<li>a professional reference letter (provided by an accountant or a lawyer stating that they know the client) </li>
<li>an original completed Source of Funds document (the template will be provided) </li>
<li>the Application and Identification Form (to be completed by BetConstruct) </li>
<li>a second ID </li>
<li>a business plan (to be provided by BetConstruct)</li>
</ul>
`,
    pricing:`
<p><span><strong>Curacao company setup and licensing process</strong></span></p>
<p><span><br></span>The following are the fee schedule for the company formation in Curacao and Cyprus (optional)
and Licensing of Curacao company. Further down you will find the fee schedule for the additional
services.</p>
</br>
<p><span>Have a look at the fees for the described areas of the Licensing services.</span></p>
</br>
<div>
<table><colgroup><col width="400"><col width="200"></colgroup>
<tbody>
<tr>
<td><span>Company Setup in Curaçao</span></td>
<td><span>10,000 EUR</span></td>
</tr>
<tr>
<td><span>Application Process for the Licence</span></td>
<td><span>13,500 EUR</span></td>
</tr>
<tr>
<td><span>Company Setup in Cyprus (optional)</span></td>
<td><span>6,000 EUR</span></td>
</tr>
</tbody>
</table>
</div>
</br>
<p><span><strong>License package provided by Antillephone: </strong></span></p>
</br>
<p>Please see details below:</p>
<ul>
<li>includes registration of 2 domains</li>
<li>each additional domain registration 2,250/domain/yr.(example: 3rd domain, 4th domain ,etc.) or unlimited domains at 12,250/yr.</li>
<li>technical compliance 3600 yr (monthly 300)</li>
<li>no hardware or servers required to be purchased, no changes to existing application infrastructure</li>
</ul>
<p><span><strong>Registration of Alias/subdomain (separate payment to Antillephone) </strong></span></p>
</br>
<p>There is a maintaining monthly fee as per below:</p>
<ul>
<li>Up to 20 registered aliases = FREE</li>
<li>20+ more mirror domains = 100/yr (for each domain) per year</li>
<li>Removal of a domain cost = 75 if the company has more than 5 domains registered • Each additional seal cost= 90 yr</li>
</ul>
<p><strong>Annual Recurring Fees (after the 1st year):</strong></p>
</br>
<div>
<table><colgroup><col width="334"><col width="266"></colgroup>
<tbody>
<tr>
<td><span>Curaçao Entity</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Annual Management</span></td>
<td><span>3,250 EUR</span></td>
</tr>
<tr>
<td><span>Registration office</span></td>
<td><span>350 EUR</span></td>
</tr>
<tr>
<td><span>Central Bank/Annual Compliance fee</span></td>
<td><span>100 EUR</span></td>
</tr>
<tr>
<td><span>Chamber of Commerce fee</span></td>
<td><span>100 EUR</span></td>
</tr>
<tr>
<td><span>Accounting & Tax</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>transaction processing (book-keeping)</span></td>
<td><span>1,000 EUR (as minimum)</span></td>
</tr>
<tr>
<td><span>preparation of financial statements</span></td>
<td><span>1,000 EUR</span></td>
</tr>
<tr>
<td><span>annual tax return</span></td>
<td><span>750 EUR</span></td>
</tr>
<tr>
<td><strong>Total Annual Recurring fees</strong></td>
<td><strong>6,550 EUR</strong></td>
</tr>
<tr>
<td><span>Cyprus Entity</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>Annual Management</span></td>
<td><span>2,250 EUR</span></td>
</tr>
<tr>
<td><span>Government fee</span></td>
<td><span>350 EUR</span></td>
</tr>
<tr>
<td><span>Registered office address</span></td>
<td><span>150 EUR</span></td>
</tr>
<tr>
<td><span>Company secretary</span></td>
<td><span>200 EUR</span></td>
</tr>
<tr>
<td><span>Accounting, Audit & Tax -&nbsp;</span><span>transaction processing (book-keeping)</span></td>
<td><span>1,000 EUR as minimum</span></td>
</tr>
<tr>
<td><span>Preparation of financial statements</span></td>
<td><span>1,000 EUR</span></td>
</tr>
<tr>
<td><span>Annual Audit/Tax</span></td>
<td><span>900 EUR</span></td>
</tr>
<tr>
<td><strong>Total Annual Recurring fees</strong></td>
<td><strong>5,850 EUR</strong></td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
</div>
<p><strong>Antillephone License annual fee - 5000</strong></p>
</br>
<p><strong>Required documents to start the project:</strong></p>
<ul>
<li><span>Notarized Copy of the Passport</span></li>
<li><span>Notarized Copy of Second ID (Second ID can be considered a Driving License or ID card)</span></li>
<li><span> Original Utility Bill issued within last three months (Certified by Notary)</span></li>
<li><span>Resume of UBO</span></li>
<li><span>Original Certificate of Good Conduct (issued within last three months) </span></li>
<li><span>Original Bank reference letter</span></li>
<li><span>Professional Reference letter (provided by accountant or lawyer stating that they know the client) - (issued within last three months)</span></li>
<li><span>Source of wealth (template will be provided )</span></li>
</ul>
<p><span>***The documents are accepted in Spanish, English and Dutch.</span></p>`
  },
  {
    name: 'Legal',
    slug: 'legal',
    icon: 'legal',
    path: 'law/Legal',
    shortDescription: `Company-Related Legal Documentation`,
    description: `
<div><img src=${require('../assets/imgs/services/Licensing.png').default} width="689" alt=""></div>
<br>
<p>Need legal help with your business growth? Here are the services we provide:</p>
<ul>
<li>Assistance in the incorporation of legal entities and opening bank accounts in reputable jurisdictions, such as Malta, UK, Isle of Man, Curacao, etc.</li>
<li>Revision, drafting and participation in negotiations: Software Licence Agreements, White Label Agreements, Consulting Agreements, Technical Service Agreements, Non-Disclosure Agreements, etc.</li>
<li>Assistance in registration of trademarks, patents, copyrights and other types of protection of intellectual property</li>
<li>Assistance in preparation of claims to arbitrations and other local courts within a particular jurisdiction</li>
</ul>
`,
    pricing:`
<p>A fixed price will be agreed between the parties for a single project.</p>
    `
  },
  //-------------------------------------------------------> Sports And Gaming
  {
    name: 'DTProService',
    slug: 'DTProService',
    icon: 'dtproservice',
    path: 'sports-and-gaming/DTProService',
    shortDescription: `Your business’s trading strategy creation and implementation.`,
    description: `
<div><img src=${require('../assets/imgs/services/DTProService.png').default} width="689" alt=""></div>
</br>
<p>Sportsbook management and customisation.</p>
</br>
<p>Our dedicated team takes full charge of your sportsbook product to ensure that it meets all the criteria for being a market-leading product and that you as a partner maximise your profits from this product.</p>
</br>
<p>That means a full cycle of product customisation:</p>
<ul>
<li>Market analysis and template set-up - markets, limits, margins, opening times per each competition, as well as market (live and pre-match),</li>
<li>Business intelligence of sportsbook performance. Daily / weekly / monthly analysis of the sportsbook-related metrics - markets, leagues, outcomes, odds values, online and retail, based on customer groups, etc.,</li>
<li>Operation of the sportsbook, management of global and local limits, reset time, VIP betting, counter-offer, cashout values, country- and currency-orientated limitations, as well as all day-to-day operational processes.</li>
<li>Additionally, provision and management of specific odds for local operation markets are included upon request.</li>
</ul>
</br>
<p>Is it possible to have a gaming business without a trading team? Of course, not. That is why our in-house bookmakers' team is there with you to raise the competitiveness of your business by providing:</p>
</br>
<ul>
<li>Odds & margins applications</li>
<li>Market types adding/removing</li>
<li>Betting limits adjustment</li>
<li>Popular events management (based on the market’s needs)</li>
<li>Reporting services</li>
<li>Bets online monitoring</li>
</ul>
`,
    pricing: `
<p>The cost of this service depends on the volume of your customers and margin, starting from 3500 EUR per month.</p>`
  },
  {
    name: 'Exclusive Risk Management',
    slug: 'ExclusiveRiskManagement',
    icon: 'exclusive-risk',
    path: 'sports-and-gaming/ExclusiveRiskManagement',
    shortDescription: `Protect your iGaming business using the highly esteemed Exclusive Risk Management service, which offers unparalleled risk mitigation and safeguards to ensure the security of your business. `,
    description: `
<div><img src=${require('../assets/imgs/services/ExclusiveRiskManagement.png').default} width="689" alt=""></div>
</br>
<p><strong>Risk Management Services</strong></p>
</br>
<p>Exclusive Risk Management has made remarkable progress in achieving excellence in the field of risk management minimising all possible losses in the igaming business. Here are the services supplied:</p>
</br>
<p>Sportsbook Risk Management</p>
<p>Casino Risk Management</p>
<p>Payments</p>
<p>Verification</p>
</br>
<p><strong>Sportsbook</strong></p>
</br>
<p>Optimize safety in Sportsbook operations with our essential Exclusive Sportsbook Risk Management service.</p>
<p><strong>What we offer in Sportsbook</strong></p>
</br>
<p>The vast Sportsbook database enables us to identify your customers, even if they are new to the website. Through the multi accounts and previous experiences in the base, the system sets a categorisation and treats customers as per the new category.</p>
</br>
<p>Our team of experts uses various programs (Odds Comparison Tool, MegaFeed, Umbrella, etc.) to identify suspicious customers and apply restrictions, as well as find profitable ones and expand their capabilities. The Exclusive Risk Management service delivers trust by:</p>
</br>
<ul>
<li>monitoring the playing behaviour of winning and losing customers;</li>
<li>identifying players who are attempting to gain an advantage in the game by putting out plausible strategies to engage in fraud</li>
<li>monitoring of new registered customers and their bets;</li>
<li>monitoring previously unknown customers, categorising them, and setting appropriate limits for each type.</li>
<li>monitoring every customer in real-time to identify their individual customizing requirements</li>
</ul>
</br>
<p>With our Sportsbook Risk Management, partners can get customer control in Live Time mode, as well as predictable turnover and minimisation of public losses. All is done to investigate suspicious cases, detect potential flaws and fraud, and thus take appropriate actions as soon as possible.</p>
</br>
<p><strong>Key features of Sportsbook</strong></p>
</br>
<ul>
<li>Customisable process 24/7</li>
<li>Service price flexibility</li>
<li>Direct communication with partners</li>
<li>Individual approach to customers</li>
<li>Generated alerts</li>
<li>Monitoring customer behaviour patterns and applying individual restrictions</li>
<li>Reporting on services provided</li>
<li>Usage of technical tools to detect the needed customers</li>
<li>Possibility to terminate the service at anytime</li>
</ul>
</br>
<p><strong>Why you need the Sportsbook</strong></p>
</br>
<p>Due to the availability of sports betting on the internet 24/7, operators have to restructure their operations to provide resources for risk management constantly. The rapid growth of Live betting has created new challenges, particularly in the areas of real-time probability and information. Indeed, betting via various sorts of gadgets is currently the fastest-growing channel in the industry, which means that players have significantly better access to real-time information. And, in order to achieve higher levels of oversight, this service comes to the rescue by:</p>
</br>
<ul>
<li>Monitoring sports events for any issues or problems within the sportsbook</li>
<li>detecting suspicious activity;</li>
<li>generating alerts;</li>
<li>analyzing sports, competitions;</li>
<li>discovering and studying match games;</li>
<li>gathering relevant evidence;</li>
<li>applying restrictions or increasing opportunities;</li>
<li>reducing potential losses;</li>
<li>checking the accuracy of coefficients;</li>
<li>checking the relationship between the time of event and the time of bet acceptance;</li>
<li>providing daily, weekly and monthly reports on customers & events to you.</li>
</ul>
</br>
<p><strong>Casino Risk Management</strong></p>
<p>Guarantee a high-quality Casino Risk Management service responsible for checking the game history, the authenticity of gameplay, turnover and RTP, and so on.</p>
</br>
<p>In Live Casino we analyse product performance and users' activity, identifying customers whose betting behaviour reveals signs of fraud, abuse and mathematical advantage play, such as signs of card counting, exploitation of equipment imperfections, money laundering, bonus/promo/tournament abuse, and others. Suspicious patterns are discovered with in-house developed tools that compile a list of potential users whose gaming behaviour meets certain criteria for known advantage play methods and frauds, and whose activity has lately been analysed and confirmed/rejected by risk management staff. At the same time, we are constantly working on developing anti-fraud methodologies to maintain a safe gaming environment for operators, providers, and their end-users.</p>
</br>
<p><strong>Key features of Casino</strong></p>
</br>
<ul>
<li>Customisable process 24/7</li>
<li>Service price flexibility</li>
<li>Direct communication with partners</li>
<li>Individual approach to customers</li>
<li>Monitoring overall product integrity</li>
<li>Checking customer behaviour patterns</li>
<li>Reporting on services provided</li>
<li>Usage of technical tools to detect the needed customers</li>
<li>Possibility to terminate the service at anytime</li>
</ul>
</br>
<p><strong>Why you need the Casino</strong></p>
</br>
<p>Providing your players with highly engaging live casino games in the finest possible way is what we do. Our specialised team is bound to manage all risks, constantly</p>
</br>
<ul>
<li>Reviewing the vast majority of Winners & Losers gaming activity;</li>
<li>verifying the authenticity of the top win by the backoffice panel;</li>
<li>checking game history to identify possible fraud;</li>
<li>checking turnover, winning payouts, RTP, deposit/withdrawal frequency, etc.;</li>
<li>checking the possibility of bonus abusing;</li>
<li>applying restrictions or blocking based on betting history.</li>
</ul>
</br>
<p>For risk-free gaming operations in your Casino, our exclusive risk management service is at your disposal.</p>
</br>
<p><strong>Payments Risk Management</strong></p>
</br>
<p>Monitor, analyse and evaluate all suspicious industrial activity and ensure seamless payments on a 24/7 basis with our Payments service.</p>
</br>
<p><strong>What we offer in Payments</strong></p>
</br>
<p>With certified professional staff, a huge database and experience in the field, we offer the finest service to our partners. Our professional team is experienced in working with over 200 payments providers and e-wallets. Payments is set up to help you via predetermined and thoroughly discussed processes, directly communicating with you and providing personalised treatment to your customers. All-important services, including in-house developed tools and the best third-party providers’ databases, are delivered at a flexible price. Also, reporting on the services provided is given to make operations far more reliable. All the necessary systems at hand, having the service is to be purely beneficial. Due to open negotiations with you, flexible service pricing is set at your request. Yet, there is a possibility to terminate the service at any time.</p>
</br>
<p><strong>Key features of Payments</strong></p>
</br>
<ul>
<li>Customisable process 24/7</li>
<li>Service price flexibility</li>
<li>Direct communication with partners</li>
<li>Individual approach to customers</li>
<li>Reporting on services provided</li>
<li>Using the “closed loop” method</li>
<li>Automatic checks</li>
<li>Possibility to terminate the service at any time</li>
</ul>
</br>
<p><strong>Why you need the Payments</strong></p>
</br>
<p>In any business, particularly in the igaming industry, each and every responsible person should manage risks. Our Payments service guarantees:</p>
</br>
<ul>
<li>highly customisable process based on relevant market requirements;</li>
<li>checks of deposits and withdrawal requests;</li>
<li>automatic checks with preset parameters;</li>
<li>withdraw funds in 0 minute with no risk;</li>
<li>minimised risk of money laundering using the “closed loop” method.</li>
</ul>
</br>
<p>All in all, this service is what you need to do risk-free payment management and make success.</p>
</br>
<p><strong>Verification</strong></p>
</br>
<p>Review documents, detect falsified ones and validate them in the most realistic environment achievable via our Verification service.</p>
</br>
<p><strong>What we offer in Verification</strong></p>
</br>
<p>Based on relevant market needs, we suggest different types of KYC process, such as identity verification, additional documents verification, including checks of source of wealth and source of funds, and what not. The verification process can be started as you demand:</p>
</br>
<ul>
<li>at the registration stage,</li>
<li>at the withdrawal request stage,</li>
<li>in case of any suspicion,</li>
<li>for receiving bonuses.</li>
</ul>
</br>
<p>The verification process is considered completed:</p>
</br>
<ul>
<li>in case the client provides identity documents only or/and;</li>
<li>in case of full EDD including additional documentation required (SOW, SOF, selfies, videoselfies, proofs of address etc.).</li>
</ul>
</br>
<p>All your decisions are to be taken into consideration. We pay attention to your needs and provide our incredible verification service to detect fake documentation, as well as ensure maximum security for authentication.</p>
</br>
<p><strong>Key features of Verification</strong></p>
</br>
<ul>
<li>Customisable process 24/7</li>
<li>Service price flexibility</li>
<li>Direct communication with partners</li>
<li>Individual approach to customers</li>
<li>Reporting on services provided</li>
<li>Double checks</li>
<li>Usage of technical tools to detect falsified documentation</li>
<li>Possibility to terminate the service at any time</li>
</ul>
</br>
<p><strong>Why you need the Verification</strong></p>
</br>
<p>Still wondering why you need this service? As documentation is an integral part of any business, verification is essentially needed. We deliver:</p>
</br>
<ul>
<li>verification process based on your demands;</li>
<li>double checking process in case of any personal detail update;</li>
<li>detection of multiple accounts;</li>
<li>document review corresponding to all jurisdiction rules and requirements;</li>
<li>usage of technical tools to detect falsified documents and fraudulent IPs.</li>
</ul>
</br>
<p>The Verification service is a perfect fit for your business to by all means avoid the falsified paperwork and exclude risks with valid documentation.</p>
`,
    pricing: `
<div>
<div>
<table><colgroup><col width="338"><col width="128"><col width="133"><col width="129"><col width="110"></colgroup>
<tbody>
<tr>
<td><span>Service type</span></td>
<td><span>&nbsp;</span></td>
<td>&nbsp;</td>
<td><span>&nbsp;</span></td>
<td>&nbsp;</td>
</tr>
<tr>
<td><span>(for the number of active players)</span></td>
<td><span>Min fee</span></td>
<td><span>50 - 499</span></td>
<td><span>500 - 999</span></td>
<td><span>1000 -</span></td>
</tr>
<tr>
<td><span>Casino RM</span></td>
<td><span>400 EUR</span></td>
<td><span>1.0</span></td>
<td><span>0.7</span></td>
<td><span>0.5</span></td>
</tr>
<tr>
<td><span>Sportsbook RM</span></td>
<td><span>800 EUR</span></td>
<td><span>2.5</span></td>
<td><span>1.8</span></td>
<td><span>1.2</span></td>
</tr>
<tr>
<td><span>KYC verification</span></td>
<td><span>150 EUR</span></td>
<td><span>0.4</span></td>
<td><span>0.35</span></td>
<td><span>0.3</span></td>
</tr>
<tr>
<td><span>Payments</span></td>
<td><span>150 EUR</span></td>
<td><span>0.4</span></td>
<td><span>0.35</span></td>
<td><span>0.3</span></td>
</tr>
</tbody>
</table>
</div>
</div>
`},
  {
    name: 'Sport Fraud Fighter',
    slug: 'SportFraudFighter',
    icon: 'sport-fraud-fighter',
    path: 'sports-and-gaming/SportFraudFighter',
    shortDescription: `To protect our members, customers, and partners from fraud in sports and other events, we require a comprehensive strategy involving multiple sectors and nations.`,
    description: `
<div><img src=${require('../assets/imgs/services/SportFraudFighter.png').default} width="689" alt=""></div>
</br>
<p>The Suspicious Sport Investigation tool is an advanced and highly capable platform crafted to assist sports organizations in the detection, investigation, and prevention of fraud and other dubious activities. It empowers investigators to actively monitor activities and gather data from diverse sources, enabling them to pinpoint patterns indicative of suspicious behavior.</p>
</br>
<p>We strive to provide the highest quality products and services to our partners and are committed to helping sports organizations protect the integrity of their sports and ensure fairness for all players.</p>
</br>
<p><strong>SFF offers</strong> an advanced anti-fraud platform that effectively detects suspicious betting activity. The company is fully prepared to:</p>
</br>
<ul>
<li>Safeguard the integrity of sports and other events by preventing criminals from exploiting regulated betting.</li>
<li>Provide a secure and trustworthy betting environment for consumers.</li>
<li>Collaborate with stakeholders at national and international levels.</li>
<li>Play a prominent role in discussions on preventing gambling-related corruption.</li>
<li>Foster evidence-based discussions to ensure the efficacy of policy initiatives.</li>
<li>Advocate for the regulation of betting as a crucial measure against match-fixing.</li>
<li>Work in partnership with the sports industry to enforce strict laws and penalties.</li>
<li>Contribute to educating sports professionals about the risks of match-fixing.</li>
</ul>
</br>
<p><strong>Curious why you need the SFF?</strong> Every single step in business is risky and dubious, and when it seems that some suspicious conduct has occurred, the company will serve you by:</p>
</br>
<ul>
<li>reporting it to the appropriate authorities, such as Sports Governing Bodies (SGBs) or Gambling Regulators (GRs), especially (but not only) those with which it has information-sharing agreements;</li>
<li>requiring those members whose markets suspect fraudulent behavior to promptly report the activity and provide material facts to the appropriate authority, such as their Gambling Regulator;</li>
<li>offering clear feedback to all members on why the alert was deemed suspicious, as well as handling the procedure for receiving investigation updates on behalf of members who have frozen suspicious wins on the Platform.</li>
</ul>
</br>
<p>We have a fundamental commitment to integrity, ensuring the protection of consumers and organizers of sports and other events against the potential risks of match-fixing in betting. In the event of detecting suspicious betting fraud, we take decisive action, including the suspension or removal of relevant betting markets. It is crucial for consumers and regulatory agencies to understand the importance of these market restrictions. Our dedicated team at SFF handles these matters with expertise, employing our own risk management procedures.</p>
</br>
<p><strong>SFM stands out with its key features that include:</strong></p>
</br>
<ul>
<li>Fraud-free bets: SFM ensures a secure and trustworthy betting environment by implementing measures to prevent fraudulent activities.</li>
<li>Fair opportunities in sports betting: SFM strives to provide equal and unbiased opportunities for bettors, maintaining fairness in the sports betting industry.</li>
<li>Extensive sources of information for extra protection: SFM leverages vast sources of information to enhance protection against potential risks and fraudulent activities.</li>
<li>Experienced sports betting professionals: SFM employs a team of skilled and knowledgeable professionals with expertise in the field of sports betting to ensure a high level of service and support for customers.</li>
</ul>
`,
    pricing: `
<p>SFF offers subscriptions that grant access to our advanced anti-fraud platform, enabling effective detection and prevention of fraudulent activities. By choosing this option, you have the opportunity to make a meaningful impact on maintaining integrity in the world of sports. Together, we can collaboratively create a safer and more transparent environment for all the parties involved.</p>
`},
  {
    name: 'Branded live dealer tables by CreedRoomz',
    slug: 'BrandedDealerByCreedRoomz',
    icon: 'branded-live-dealer',
    path: 'sports-and-gaming/BrandedDealerByCreedRoomz',
    shortDescription: `CreedRoomz provides unique solutions for both dedicated tables and studios to make your brand distinctive.`,
    description: `
<div><img src=${require('../assets/imgs/services/BrandedDealerByCreedRoomz.png').default} width="689" alt=""></div>
</br>
<p>It is fully equipped to reflect your casino brand ideally and create a memorable gaming experience for your customers. By requesting dedicated services, an operator receives a full arsenal of our products, services and tools to build a live casino that reflects their own brand. Key aspects include:<strong> games, language of dealers, table or studio design, roulette tables, custom playing cards, website landing page, live casino lobby & elements of the UI.</strong></p>
</br>
<p>Upon special request, the operator can also offer and build innovative, high-end special tables for BlackJack and Roulette games in <strong>Private Atrium</strong>fully tailored to their brand. The players will receive the highest levels of personal <strong>one-to-one service</strong> and will be able to exercise control over the dealer, the shuffling, and <strong>talk to dealers via voice messages.</strong> As things progress, you will delight your players, which will lead to an increased customer base and long-term business growth.</p>
`,
    pricing: `
<div>
<p>ONE TIME SET-UP FEE</p>
</br>
<p>1 camera card table – 15.000 EUR<br> 3 camera card table – 35.000 EUR</p>
</br>
<p>3 camera roulette table – 35.000 EUR<br> 5 camera roulette table – 45.000 EUR<br> 7 camera roulette table – 55.000 EUR</p>
</br>
<p>MONTHLY FEE</p>
</br>
<p>Per table 10.000eur /starting from 3 tables – 8.000&nbsp;EUR</p>
</div>`
  },
  {
    name: 'Wonder Wheel Promotional Tool',
    slug: 'WonderWheelPromotionalTool',
    icon: 'wonder-wheel',
    path: 'sports-and-gaming/WonderWheelPromotionalTool', //TODO
    shortDescription: `Wonder Wheel is a promotional tool that allows your players to spin the wheel for exciting prizes.`,
    description: `
<div><img src=${require('../assets/imgs/services/WonderWheelPromotionalTool.png').default} width="689" alt=""></div>
</br>
<p>Wonder Wheel is a separate promotional page where the players can win the prizes displayed in different sections of the wheel by spinning it with no option of losing. There are instant winnings when the players spin the Wonder Wheel and win the prize in the direction of the arrow and symbolic winnings when the players collect the corresponding amount of symbols and receive the displayed prize. In order to have a spin, the players are required to fulfill certain scales which are fully customizable.</p>
</br>
<p><strong>How can Wonder Wheel benefit our operators?</strong></p>
</br>
<ul>
<li>Become highly competitive in the market.</li>
</ul>
</br>
<p>Wonder Wheel will help the operators to become very competitive in their markets.</p>
</br>
<ul>
<li>More Active Players</li>
</ul>
</br>
<p>Players will visit the operator’s website every day (predefined period of time) to collect their Wonder Wheel free spins. Also, to receive more Wonder Wheel spins the players will play more, thus increasing the play session length.</p>
</br>
<ul>
<li>New Players</li>
</ul>
</br>
<p>The opportunity to receive Wonder Wheel spins and win big prizes with no chance of losing will bring new players to the operator's website.</p>
</br>
<ul>
<li>Players Loyalty</li>
</ul>
</br>
<p>The excitement and engagement that Wonder Wheel brings to players will have a positive impact on the Player’s loyalty.</p>
</br>
<ul>
<li>Increase the Turnover</li>
</ul>
</br>
<p>To receive more Wonder Wheel spins, the players will play more, thus increasing the overall turnover.</p>
</br>
<ul>
<li>Promote Games</li>
</ul>
</br>
<p>The players will play the Operator’s offered games to receive more Wonder Wheel spins.</p>
`,
    pricing: `
<p>A fixed monthly rate will be agreed between the parties.</p>`
  },
  {
    name: 'iGaming Bot',
    slug: 'iGamingBot',
    icon: 'iGaming-bot',
    path: 'sports-and-gaming/iGamingBot',
    shortDescription: `in-Telegram application to play, chat and connect 1+ billion of people to your brand`,
    description: `
<div><img src=${require('../assets/imgs/services/iGamingBot.png').default} width="689" alt=""></div>
</br>
<p>iGaming Bot is an application provided by BetConstruct that operates inside Telegram (the popular messaging app with over 1 billion users). It provides popular iGaming functions in addition to your website and mobile application.</p>
<p>For example, your players can use bot to:</p>
</br>
<ul>
<li>Play slots</li>
<li>Make deposit or withdrawal,</li>
<li>Verify account or payment method</li>
<li>Chat with support</li>
<li>AI-assistant</li>
<li>Place a bet (coming soon)</li>
</ul>
</br>
<p>Run iGaming casino & sportsbook in Telegram without any blocking by AppStore or GooglePlay. Telegram is in the top-3 popular messaging app with over 1 billion users worldwide/</p>
</br>
<p>iGaming Bot unique value:</p>
</br>
<ul>
<li>Our bot operates worldwide on a reliable trusted iGaming platform with 600+ b2b partners</li>
<li>Bot provides high security of players data. We don’t store user passwords, credit cards numbers or other payment details in bot</li>
<li>Bot supports player restrictions such as timeouts, ludoman, users blocking, regulator restrictions </li>
<li>We support crypto and hundreds of payment methods specific for your region, and BetConstruct’s own crypto currency - Fasttoken</li>
<li>The only bot that will provide sportsbook! (we work on it right now)</li>
</ul>
`,
    pricing: `
<div>
<ul>
<li>Setup fee - FREE</li>
<li>Service fee - EUR 1,200 per month</li>
<li>Customization - contact your account manager</li>
</ul>
</div>
`},
  //-------------------------------------------------------> Other
  {
    name: 'Customer Support',
    slug: 'CustomerSupport',
    icon: 'customer-support',
    path: 'other/CustomerSupport',
    shortDescription: `Experienced Live Customer Support in over 16 languages, 24/7`,
    description: `
<div><img src=${require('../assets/imgs/services/CustomerSupport.png').default} width="689" alt=""></div>
</br>
<p>Do you want your customers to get 24/7 support in 16 different languages with industry-leading response times?</p>
</br>
<p>Our award-winning Customer Service solution can take your players’ satisfaction and engagement to the next level.</p>
</br>
<p>We offer professional support to International Partners within the online gambling industry wherein impeccable customer service is a necessity. Through this solution, you can build trust with your customers by tackling simple queries related to the toughest technical issues.</p>
</br>
<p>We provide customer support via live chat and email. Packages for Inbound / Outbound Calls, VIP Support, Customer Acquisition, Retention and Social Media Customer Service are also available upon request.</p>
</br>
<p>We believe our solution can exceed expectations in terms of relevant experience, licence and regulation accreditation, technological infrastructure, reporting transparency, people and value for money.</p>
`,
    pricing: `
<p>A fixed price will be agreed between the parties for a single project.</p>
    `
  },
  {
    name: 'Data replication Services',
    slug: 'DataReplicationServices',
    icon: 'data-replication-services',
    path: 'other/DataReplicationServices',
    shortDescription: `Deliver real-time data to derive better insights.`,
    description: `
<div><img src=${require('../assets/imgs/services/DataReplicationServices.png').default} width="689" alt=""></div>
</br>
<p>Nothing is more important than data in today’s world. The importance of Data Replication is an adamant thing that every business has to adapt to survive in the competition.</p>
</br>
<p>The idea of Partner Data Replication service is to store the same data in multiple locations so that everyone connected to it distributes the system and has access to the same shared data.</p>
</br>
<p>BetConstruct uses what’s known as a Virtual Private Network, or VPN, running over the Internet to transmit data in replicated scenarios. A VPN can be set up on any computer and offers a secure channel, via passwords and/or data encryption, for data to flow. So you get the ease and pervasiveness of the Internet with the security of the VPN.</p>
</br>
<p>The process of Data Replication can provide the following major advantages to your business:</p>
</br>
<ul>
<li>Ensure a consistent copy of the data across all nodes in the Database. As a result of this, data is more easily available.</li>
<li>BetConstruct replicates all the necessary data from the partner's service to theirs, to help the partner avoid blocking of the website.</li>
<li>Data reliability is enhanced by Data Replication. Moreover, it allows multiple users and provides high performance.</li>
<li>Player's data, profiles, all transactions, and bets are safely mirrored on your on-premise servers.</li>
<li>Because copies are made, there is a possibility that the data will be present where the transaction is being performed. This reduces data movement. It increases the speed of query execution which saves you and your company a lot of time.</li>
</ul>
</br>
<p>For this to happen, you should provide root access to connect and configure an environment (VPN, MSSQL configurations, firewall, etc…) and have a minimum of 20000 daily active players. Betconstruct, in turn, maintains the server and provides access to the database to you.</p>
`,
    pricing: `
<p>Pricing for this service is available upon request.</p>`
  },
  {
    name: 'Enigma',
    slug: 'Enigma',
    icon: 'enigma',
    path: 'other/Enigma',
    shortDescription: `Improve your data quality and use our insights to better target your customers.`,
    description: `
<div><img src=${require('../assets/imgs/services/Enigma.png').default} width="689" alt=""></div>
</br>
<p>Enigma is a real-time data delivery service.</p>
</br>
<p>With cutting-edge technologies and battle-tested tools accompanied by the skill and knowledge of our team, we help businesses move from <strong>“What happened”</strong> all the way to the game-changing <strong>“How can we make it happen”</strong>.</p>
</br>
<p>Enigma will help your business develop an analytics capability with solutions that will enable your business to make informed decisions based on all the data available to it.</p>
<p>Providing data analysis will also enable you to discover deeper insights, predictions and/or generate recommendations.</p>
</br>
<p>We guarantee the delivery of 99% of the data. Our clients receive the data each day through an analytics system that enables them to work with the data in the way they want.</p>
<p>With Enigma, your project is delivered with specialised expertise, proven frameworks and constant collaboration.</p>
</br>
<p><strong>The types of data you will receive:</strong></p>
</br>
<ul>
<li>Client details data</li>
<li>SportBook data</li>
<li>Casino data</li>
<li>Finance data</li>
</ul>
</br>
<p><strong>This data package can be used in these fields:</strong></p>
</br>
<ul>
<li>Analytics</li>
<li>Risk management</li>
<li>Marketing</li>
<li>Operating system</li>
</ul>
</br>
<p><strong>Technical description</strong></p>
</br>
<p>We use Kafka components to deliver real-time data.</p>
</br>
<p>We use a completely secure data delivery solution.</p>
</br>
<p>You can receive data in two formats:</p>
</br>
<ul>
<li>Avro schema</li>
<li>JSON schema</li>
</ul>
`,
    pricing: `
<div>
<table>
<tbody>
<tr style="height: 13px;">
<td style="height: 13px;"><span>0 - 1.000.000 transaction /day</span></td>
<td style="height: 13px;">1500 EUR</td>
</tr>
<tr style="height: 13px;">
<td style="height: 13px;"><span>1.000.000 - 2.000.000 transaction /day </span></td>
<td style="height: 13px;">2500 EUR</td>
</tr>
<tr style="height: 13px;">
<td style="height: 13px;"><span>2.000.000 - 10.000.000 transactions/day</span></td>
<td style="height: 13px;">3500 EUR</td>
</tr>
<tr style="height: 13px;">
<td style="height: 13px;"><span>Over 10.000.000 transactions/day </span></td>
<td style="height: 13px;"><span>contract price</span></td>
</tr>
</tbody>
</table>
</div>
`
  },
  {
    name: 'Event Management and Logistics Services',
    slug: 'EventManagementLogisticsServices',
    icon: 'event-management-logistics-services',
    path: 'other/EventManagementLogisticsServices',
    shortDescription: `Wide range of services starting from ad placement advisory to stand design and construction.`,
    description: `
<div><img src=${require('../assets/imgs/services/EventManagementLogisticsServices.png').default} width="689" alt=""></div>
</br>
<p>We provide tailor-made and complete solutions to manage your event participation from conceptualisation to execution. We design, build, manage and install exhibition stands all over the world offering a complete package that will meet every requirement and fit your budget.</p>
</br>
<p>Our team of professionals has over 10 years of experience. We are passionate about what we do and guarantee that our expertise will help you reach your target audience. Teaming up with industry-focussed manufacturing teams and design professionals, our dedicated project managers all have one purpose - to help you stand out.</p>
</br>
<p>If you don’t have an in-house or outsourced design team, our design department is ready to turn all your ideas into reality. Also, we are ready to consult and work with your team, or if you're an agency, we can work with you or your client either out front or behind the scenes.</p>
</br>
<p>We will customize your exhibition stand design to match your budget and suggest effective ways to maximize your showcase potential in a way that will increase the number of visitors. Whether you need assistance in executing separate sub-projects of your project or a full A to Z business showcase at an event, we have your back.</p>
</br>
<p><strong><u>Key Features</u></strong></p>
</br>
<ul>
<li>Event showcase strategy consulting</li>
<li>Professional logistics consulting</li>
<li>Budget-friendly services for every customer</li>
<li>Sponsorship and ad placement advisory</li>
<li>Stand design, construction and assembly</li>
<li>Hiring talents, catering and furniture rental</li>
<li>Sound and visual as well as marketing materials</li>
<li>Multilingual service</li>
<li>24/7 support</li>
<li>Worldwide operation</li>
</ul>
`,
    pricing: `
<p>The prices may vary depending on:</p>
<ul>
<li>The event (expo, conference, workshop, open-air event)</li>
<li>The size of the stand</li>
<li>The applied design</li>
</ul>
<p>A fixed price will be agreed between the parties for a single project.</p>
`
  },
];
